//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming



export abstract class NaarGoResponse implements INaarGoResponse {
    requestID?: string | null;
    timestamp?: number;
    uniqueID?: string;

    constructor(data?: INaarGoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestID = _data["requestID"] !== undefined ? _data["requestID"] : null as any;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : null as any;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : null as any;
        }
    }

    static fromJS(data: any): NaarGoResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'NaarGoResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestID"] = this.requestID !== undefined ? this.requestID : null as any;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : null as any;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : null as any;
        return data;
    }
}

export interface INaarGoResponse {
    requestID?: string | null;
    timestamp?: number;
    uniqueID?: string;
}

export class OkNaarGoResponse extends NaarGoResponse implements IOkNaarGoResponse {
    result?: ENaarGoResponseResult;

    constructor(data?: IOkNaarGoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static override fromJS(data: any): OkNaarGoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OkNaarGoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IOkNaarGoResponse extends INaarGoResponse {
    result?: ENaarGoResponseResult;
}

export class NaarGoLoginResponse extends OkNaarGoResponse implements INaarGoLoginResponse {
    user?: NaarGoUserRow;

    constructor(data?: INaarGoLoginResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? NaarGoUserRow.fromJS(_data["user"]) : null as any;
        }
    }

    static override fromJS(data: any): NaarGoLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoLoginResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoLoginResponse extends IOkNaarGoResponse {
    user?: NaarGoUserRow;
}

export class NaarGoCheckResponse extends NaarGoLoginResponse implements INaarGoCheckResponse {
    isDebug?: boolean;
    naarDatabaseServer?: string | null;
    naarDatabaseName?: string | null;

    constructor(data?: INaarGoCheckResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isDebug = _data["isDebug"] !== undefined ? _data["isDebug"] : null as any;
            this.naarDatabaseServer = _data["naarDatabaseServer"] !== undefined ? _data["naarDatabaseServer"] : null as any;
            this.naarDatabaseName = _data["naarDatabaseName"] !== undefined ? _data["naarDatabaseName"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoCheckResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDebug"] = this.isDebug !== undefined ? this.isDebug : null as any;
        data["naarDatabaseServer"] = this.naarDatabaseServer !== undefined ? this.naarDatabaseServer : null as any;
        data["naarDatabaseName"] = this.naarDatabaseName !== undefined ? this.naarDatabaseName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoCheckResponse extends INaarGoLoginResponse {
    isDebug?: boolean;
    naarDatabaseServer?: string | null;
    naarDatabaseName?: string | null;
}

export class NaarGoUserRowLite implements INaarGoUserRowLite {
    id?: number;
    azureCSIdentity?: string | null;
    role?: EUserRole;

    constructor(data?: INaarGoUserRowLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.azureCSIdentity = _data["azureCSIdentity"] !== undefined ? _data["azureCSIdentity"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
        }
    }

    static fromJS(data: any): NaarGoUserRowLite {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoUserRowLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["azureCSIdentity"] = this.azureCSIdentity !== undefined ? this.azureCSIdentity : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        return data;
    }
}

export interface INaarGoUserRowLite {
    id?: number;
    azureCSIdentity?: string | null;
    role?: EUserRole;
}

export class NaarGoUserRow extends NaarGoUserRowLite implements INaarGoUserRow {
    emailAddress?: string | null;
    name?: string | null;
    lastname?: string | null;
    azureCSToken?: string | null;
    authToken?: string | null;
    language?: ELingua;
    intranetUserID?: number | null;
    lastAccess?: Date | null;
    deletedDate?: Date | null;

    constructor(data?: INaarGoUserRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : null as any;
            this.azureCSToken = _data["azureCSToken"] !== undefined ? _data["azureCSToken"] : null as any;
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.intranetUserID = _data["intranetUserID"] !== undefined ? _data["intranetUserID"] : null as any;
            this.lastAccess = _data["lastAccess"] ? new Date(_data["lastAccess"].toString()) : null as any;
            this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : null as any;
        }
    }

    static override fromJS(data: any): NaarGoUserRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoUserRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["lastname"] = this.lastname !== undefined ? this.lastname : null as any;
        data["azureCSToken"] = this.azureCSToken !== undefined ? this.azureCSToken : null as any;
        data["authToken"] = this.authToken !== undefined ? this.authToken : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["intranetUserID"] = this.intranetUserID !== undefined ? this.intranetUserID : null as any;
        data["lastAccess"] = this.lastAccess ? this.lastAccess.toISOString() : null as any;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoUserRow extends INaarGoUserRowLite {
    emailAddress?: string | null;
    name?: string | null;
    lastname?: string | null;
    azureCSToken?: string | null;
    authToken?: string | null;
    language?: ELingua;
    intranetUserID?: number | null;
    lastAccess?: Date | null;
    deletedDate?: Date | null;
}

export enum ELingua {
    Italiano = "Italiano",
    English = "English",
    Francais = "Francais",
    Deutsch = "Deutsch",
    Dutch = "Dutch",
    Spanish = "Spanish",
    Portuguese = "Portuguese",
    Debug = "Debug",
}

export enum EUserRole {
    User = "User",
    Admin = "Admin",
    System = "System",
}

export enum ENaarGoResponseResult {
    Ok = "Ok",
    Error = "Error",
}

export abstract class NaarGoRequest implements INaarGoRequest {
    uniqueID?: string | null;

    constructor(data?: INaarGoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : null as any;
        }
    }

    static fromJS(data: any): NaarGoRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'NaarGoRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : null as any;
        return data;
    }
}

export interface INaarGoRequest {
    uniqueID?: string | null;
}

export class NaarGoCheckRequest extends NaarGoRequest implements INaarGoCheckRequest {
    csIdentity?: string;

    constructor(data?: INaarGoCheckRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.csIdentity = _data["csIdentity"] !== undefined ? _data["csIdentity"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoCheckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoCheckRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["csIdentity"] = this.csIdentity !== undefined ? this.csIdentity : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoCheckRequest extends INaarGoRequest {
    csIdentity?: string;
}

export class NaarGoLoginRequest extends NaarGoRequest implements INaarGoLoginRequest {
    emailAddress!: string;
    password!: string;

    constructor(data?: INaarGoLoginRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoLoginRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoLoginRequest extends INaarGoRequest {
    emailAddress: string;
    password: string;
}

export class NaarGoTokenResponse extends OkNaarGoResponse implements INaarGoTokenResponse {
    csToken?: string;
    authToken?: string;

    constructor(data?: INaarGoTokenResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.csToken = _data["csToken"] !== undefined ? _data["csToken"] : null as any;
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTokenResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["csToken"] = this.csToken !== undefined ? this.csToken : null as any;
        data["authToken"] = this.authToken !== undefined ? this.authToken : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoTokenResponse extends IOkNaarGoResponse {
    csToken?: string;
    authToken?: string;
}

export class NaarGoRequestPasswordResetRequest extends NaarGoRequest implements INaarGoRequestPasswordResetRequest {
    emailAddress!: string;

    constructor(data?: INaarGoRequestPasswordResetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoRequestPasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoRequestPasswordResetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoRequestPasswordResetRequest extends INaarGoRequest {
    emailAddress: string;
}

export class NaarGoResetPasswordRequest extends NaarGoRequest implements INaarGoResetPasswordRequest {
    emailAddress!: string;
    code!: string;
    password!: string;

    constructor(data?: INaarGoResetPasswordRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoResetPasswordRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoResetPasswordRequest extends INaarGoRequest {
    emailAddress: string;
    code: string;
    password: string;
}

export class NaarGoSignupRequest extends NaarGoRequest implements INaarGoSignupRequest {
    emailAddress!: string;
    password!: string;
    name!: string;
    lastname!: string;
    language!: ELingua;

    constructor(data?: INaarGoSignupRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoSignupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoSignupRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["lastname"] = this.lastname !== undefined ? this.lastname : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoSignupRequest extends INaarGoRequest {
    emailAddress: string;
    password: string;
    name: string;
    lastname: string;
    language: ELingua;
}

export class NaarGoResendCodeRequest extends NaarGoRequest implements INaarGoResendCodeRequest {
    emailAddress!: string;

    constructor(data?: INaarGoResendCodeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoResendCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoResendCodeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoResendCodeRequest extends INaarGoRequest {
    emailAddress: string;
}

export class NaarGoConfirmEmailRequest extends NaarGoRequest implements INaarGoConfirmEmailRequest {
    emailAddress!: string;
    code!: string;

    constructor(data?: INaarGoConfirmEmailRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoConfirmEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoConfirmEmailRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoConfirmEmailRequest extends INaarGoRequest {
    emailAddress: string;
    code: string;
}

export class FileUploadResponse extends OkNaarGoResponse implements IFileUploadResponse {
    guid?: string;

    constructor(data?: IFileUploadResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
        }
    }

    static override fromJS(data: any): FileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFileUploadResponse extends IOkNaarGoResponse {
    guid?: string;
}

export class ErrorNaarGoResponse extends NaarGoResponse implements IErrorNaarGoResponse {
    result?: ENaarGoResponseResult;
    exceptionType?: ENaarGoExceptionType | null;

    constructor(data?: IErrorNaarGoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
            this.exceptionType = _data["exceptionType"] !== undefined ? _data["exceptionType"] : null as any;
        }
    }

    static override fromJS(data: any): ErrorNaarGoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorNaarGoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        data["exceptionType"] = this.exceptionType !== undefined ? this.exceptionType : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IErrorNaarGoResponse extends INaarGoResponse {
    result?: ENaarGoResponseResult;
    exceptionType?: ENaarGoExceptionType | null;
}

export enum ENaarGoExceptionType {
    Generic = "Generic",
    EmailExists = "EmailExists",
    EmailNotFound = "EmailNotFound",
    FileDownload = "FileDownload",
    FileUpload = "FileUpload",
    InvalidOTP = "InvalidOTP",
    InvalidResetCode = "InvalidResetCode",
    LoginFailed = "LoginFailed",
    PasswordMismatch = "PasswordMismatch",
    ServiceNotFound = "ServiceNotFound",
    TripNotFound = "TripNotFound",
    UserNotFound = "UserNotFound",
    UserTripExists = "UserTripExists",
    EmailInvalid = "EmailInvalid",
    NetworkError = "NetworkError",
    PasswordLength = "PasswordLength",
    PasswordStrength = "PasswordStrength",
    RequiredField = "RequiredField",
}

export class FileDownloadResponse extends OkNaarGoResponse implements IFileDownloadResponse {
    bytes?: string;

    constructor(data?: IFileDownloadResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bytes = _data["bytes"] !== undefined ? _data["bytes"] : null as any;
        }
    }

    static override fromJS(data: any): FileDownloadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bytes"] = this.bytes !== undefined ? this.bytes : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFileDownloadResponse extends IOkNaarGoResponse {
    bytes?: string;
}

export class FileDownloadRequest extends NaarGoRequest implements IFileDownloadRequest {
    threadId?: string;
    guid?: string;
    getPreview?: boolean;

    constructor(data?: IFileDownloadRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.threadId = _data["threadId"] !== undefined ? _data["threadId"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.getPreview = _data["getPreview"] !== undefined ? _data["getPreview"] : null as any;
        }
    }

    static override fromJS(data: any): FileDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadId"] = this.threadId !== undefined ? this.threadId : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["getPreview"] = this.getPreview !== undefined ? this.getPreview : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFileDownloadRequest extends INaarGoRequest {
    threadId?: string;
    guid?: string;
    getPreview?: boolean;
}

export class NaarGoNotificationSubscribeRequest extends NaarGoRequest implements INaarGoNotificationSubscribeRequest {
    userId?: number;
    subscription?: PushSubscription;

    constructor(data?: INaarGoNotificationSubscribeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.subscription = _data["subscription"] ? PushSubscription.fromJS(_data["subscription"]) : null as any;
        }
    }

    static override fromJS(data: any): NaarGoNotificationSubscribeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoNotificationSubscribeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoNotificationSubscribeRequest extends INaarGoRequest {
    userId?: number;
    subscription?: PushSubscription;
}

export class PushSubscription implements IPushSubscription {
    endpoint?: string | null;
    p256DH?: string | null;
    auth?: string | null;

    constructor(data?: IPushSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"] !== undefined ? _data["endpoint"] : null as any;
            this.p256DH = _data["p256DH"] !== undefined ? _data["p256DH"] : null as any;
            this.auth = _data["auth"] !== undefined ? _data["auth"] : null as any;
        }
    }

    static fromJS(data: any): PushSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new PushSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint !== undefined ? this.endpoint : null as any;
        data["p256DH"] = this.p256DH !== undefined ? this.p256DH : null as any;
        data["auth"] = this.auth !== undefined ? this.auth : null as any;
        return data;
    }
}

export interface IPushSubscription {
    endpoint?: string | null;
    p256DH?: string | null;
    auth?: string | null;
}

export class NaarGoNotificationUnsubscribeRequest extends NaarGoRequest implements INaarGoNotificationUnsubscribeRequest {
    userId?: number;

    constructor(data?: INaarGoNotificationUnsubscribeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoNotificationUnsubscribeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoNotificationUnsubscribeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoNotificationUnsubscribeRequest extends INaarGoRequest {
    userId?: number;
}

export class GetServiceResponse extends OkNaarGoResponse implements IGetServiceResponse {
    service?: ServiceData;

    constructor(data?: IGetServiceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.service = _data["service"] ? ServiceData.fromJS(_data["service"]) : null as any;
        }
    }

    static override fromJS(data: any): GetServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceResponse extends IOkNaarGoResponse {
    service?: ServiceData;
}

export class ServiceData implements IServiceData {
    id?: string;
    servizioID?: number;
    interno?: boolean;
    prezzoBase?: number | null;
    nome?: string | null;
    sottoTitolo?: string | null;
    stringaRicerca?: string | null;
    indirizzo?: string | null;
    altroLuogo?: boolean;
    luogo?: string | null;
    destinazioneID?: number | null;
    cover?: string | null;
    durata?: ServiceDuration | null;
    stelle?: number | null;
    urlName?: string | null;
    mappa?: Mappa | null;
    attributiFiltro?: number[] | null;
    haAttributiTestata?: boolean;
    haCategoria?: boolean;
    categoria?: string | null;
    haNuovo?: boolean;
    nuovo?: string | null;
    haVantaggi?: boolean;
    vantaggi?: string | null;
    haServizi?: boolean;
    inRistrutturazione?: string | null;
    tipoServizio?: ETipoServizio;
    popolarita?: number | null;
    haAttributiNoleggi?: boolean;
    attributiNoleggi?: ElencoAttributiNoleggio[] | null;
    tappe?: (string | null)[] | null;
    luoghi?: number[] | null;
    date?: ServiceDeparture[] | null;
    attributi?: ServiceAttribute[] | null;
    preferito?: boolean;
    prezzi?: ServizioSearch | null;
    testiPrincipali?: TestoCompleto[] | null;
    testiGiorni?: TestoCompleto[] | null;
    testiNote?: TestoCompleto[] | null;
    itinerario?: (ServiceItineraryStep | null)[] | null;
    immagini?: ServiceImage[] | null;
    partenzePerFiltri?: ServiceDepartureFilterValues | null;
    regolePacchetto?: ServizioRegolaScontoPacchetto[] | null;
    tipologie?: TipologieServiziItinerario[] | null;
    providerContact?: ServiceProviderContact;
    departureAirports?: PackageDepartureAirports[] | null;
    airlines?: PackageAirlines[] | null;

    constructor(data?: IServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.interno = _data["interno"] !== undefined ? _data["interno"] : null as any;
            this.prezzoBase = _data["prezzoBase"] !== undefined ? _data["prezzoBase"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.sottoTitolo = _data["sottoTitolo"] !== undefined ? _data["sottoTitolo"] : null as any;
            this.stringaRicerca = _data["stringaRicerca"] !== undefined ? _data["stringaRicerca"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.altroLuogo = _data["altroLuogo"] !== undefined ? _data["altroLuogo"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.destinazioneID = _data["destinazioneID"] !== undefined ? _data["destinazioneID"] : null as any;
            this.cover = _data["cover"] !== undefined ? _data["cover"] : null as any;
            this.durata = _data["durata"] ? ServiceDuration.fromJS(_data["durata"]) : null as any;
            this.stelle = _data["stelle"] !== undefined ? _data["stelle"] : null as any;
            this.urlName = _data["urlName"] !== undefined ? _data["urlName"] : null as any;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
            if (Array.isArray(_data["attributiFiltro"])) {
                this.attributiFiltro = [] as any;
                for (let item of _data["attributiFiltro"])
                    this.attributiFiltro!.push(item);
            }
            else {
                this.attributiFiltro = null as any;
            }
            this.haAttributiTestata = _data["haAttributiTestata"] !== undefined ? _data["haAttributiTestata"] : null as any;
            this.haCategoria = _data["haCategoria"] !== undefined ? _data["haCategoria"] : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.haNuovo = _data["haNuovo"] !== undefined ? _data["haNuovo"] : null as any;
            this.nuovo = _data["nuovo"] !== undefined ? _data["nuovo"] : null as any;
            this.haVantaggi = _data["haVantaggi"] !== undefined ? _data["haVantaggi"] : null as any;
            this.vantaggi = _data["vantaggi"] !== undefined ? _data["vantaggi"] : null as any;
            this.haServizi = _data["haServizi"] !== undefined ? _data["haServizi"] : null as any;
            this.inRistrutturazione = _data["inRistrutturazione"] !== undefined ? _data["inRistrutturazione"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : null as any;
            this.haAttributiNoleggi = _data["haAttributiNoleggi"] !== undefined ? _data["haAttributiNoleggi"] : null as any;
            if (Array.isArray(_data["attributiNoleggi"])) {
                this.attributiNoleggi = [] as any;
                for (let item of _data["attributiNoleggi"])
                    this.attributiNoleggi!.push(ElencoAttributiNoleggio.fromJS(item));
            }
            else {
                this.attributiNoleggi = null as any;
            }
            if (Array.isArray(_data["tappe"])) {
                this.tappe = [] as any;
                for (let item of _data["tappe"])
                    this.tappe!.push(item);
            }
            else {
                this.tappe = null as any;
            }
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(item);
            }
            else {
                this.luoghi = null as any;
            }
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(ServiceDeparture.fromJS(item));
            }
            else {
                this.date = null as any;
            }
            if (Array.isArray(_data["attributi"])) {
                this.attributi = [] as any;
                for (let item of _data["attributi"])
                    this.attributi!.push(ServiceAttribute.fromJS(item));
            }
            else {
                this.attributi = null as any;
            }
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : null as any;
            this.prezzi = _data["prezzi"] ? ServizioSearch.fromJS(_data["prezzi"]) : null as any;
            if (Array.isArray(_data["testiPrincipali"])) {
                this.testiPrincipali = [] as any;
                for (let item of _data["testiPrincipali"])
                    this.testiPrincipali!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testiPrincipali = null as any;
            }
            if (Array.isArray(_data["testiGiorni"])) {
                this.testiGiorni = [] as any;
                for (let item of _data["testiGiorni"])
                    this.testiGiorni!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testiGiorni = null as any;
            }
            if (Array.isArray(_data["testiNote"])) {
                this.testiNote = [] as any;
                for (let item of _data["testiNote"])
                    this.testiNote!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testiNote = null as any;
            }
            if (Array.isArray(_data["itinerario"])) {
                this.itinerario = [] as any;
                for (let item of _data["itinerario"])
                    this.itinerario!.push(ServiceItineraryStep.fromJS(item));
            }
            else {
                this.itinerario = null as any;
            }
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(ServiceImage.fromJS(item));
            }
            else {
                this.immagini = null as any;
            }
            this.partenzePerFiltri = _data["partenzePerFiltri"] ? ServiceDepartureFilterValues.fromJS(_data["partenzePerFiltri"]) : null as any;
            if (Array.isArray(_data["regolePacchetto"])) {
                this.regolePacchetto = [] as any;
                for (let item of _data["regolePacchetto"])
                    this.regolePacchetto!.push(ServizioRegolaScontoPacchetto.fromJS(item));
            }
            else {
                this.regolePacchetto = null as any;
            }
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(TipologieServiziItinerario.fromJS(item));
            }
            else {
                this.tipologie = null as any;
            }
            this.providerContact = _data["providerContact"] ? ServiceProviderContact.fromJS(_data["providerContact"]) : null as any;
            if (Array.isArray(_data["departureAirports"])) {
                this.departureAirports = [] as any;
                for (let item of _data["departureAirports"])
                    this.departureAirports!.push(PackageDepartureAirports.fromJS(item));
            }
            else {
                this.departureAirports = null as any;
            }
            if (Array.isArray(_data["airlines"])) {
                this.airlines = [] as any;
                for (let item of _data["airlines"])
                    this.airlines!.push(PackageAirlines.fromJS(item));
            }
            else {
                this.airlines = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["interno"] = this.interno !== undefined ? this.interno : null as any;
        data["prezzoBase"] = this.prezzoBase !== undefined ? this.prezzoBase : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["sottoTitolo"] = this.sottoTitolo !== undefined ? this.sottoTitolo : null as any;
        data["stringaRicerca"] = this.stringaRicerca !== undefined ? this.stringaRicerca : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["altroLuogo"] = this.altroLuogo !== undefined ? this.altroLuogo : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["destinazioneID"] = this.destinazioneID !== undefined ? this.destinazioneID : null as any;
        data["cover"] = this.cover !== undefined ? this.cover : null as any;
        data["durata"] = this.durata ? this.durata.toJSON() : null as any;
        data["stelle"] = this.stelle !== undefined ? this.stelle : null as any;
        data["urlName"] = this.urlName !== undefined ? this.urlName : null as any;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        if (Array.isArray(this.attributiFiltro)) {
            data["attributiFiltro"] = [];
            for (let item of this.attributiFiltro)
                data["attributiFiltro"].push(item);
        }
        data["haAttributiTestata"] = this.haAttributiTestata !== undefined ? this.haAttributiTestata : null as any;
        data["haCategoria"] = this.haCategoria !== undefined ? this.haCategoria : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["haNuovo"] = this.haNuovo !== undefined ? this.haNuovo : null as any;
        data["nuovo"] = this.nuovo !== undefined ? this.nuovo : null as any;
        data["haVantaggi"] = this.haVantaggi !== undefined ? this.haVantaggi : null as any;
        data["vantaggi"] = this.vantaggi !== undefined ? this.vantaggi : null as any;
        data["haServizi"] = this.haServizi !== undefined ? this.haServizi : null as any;
        data["inRistrutturazione"] = this.inRistrutturazione !== undefined ? this.inRistrutturazione : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : null as any;
        data["haAttributiNoleggi"] = this.haAttributiNoleggi !== undefined ? this.haAttributiNoleggi : null as any;
        if (Array.isArray(this.attributiNoleggi)) {
            data["attributiNoleggi"] = [];
            for (let item of this.attributiNoleggi)
                data["attributiNoleggi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tappe)) {
            data["tappe"] = [];
            for (let item of this.tappe)
                data["tappe"].push(item);
        }
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item);
        }
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.attributi)) {
            data["attributi"] = [];
            for (let item of this.attributi)
                data["attributi"].push(item ? item.toJSON() : null as any);
        }
        data["preferito"] = this.preferito !== undefined ? this.preferito : null as any;
        data["prezzi"] = this.prezzi ? this.prezzi.toJSON() : null as any;
        if (Array.isArray(this.testiPrincipali)) {
            data["testiPrincipali"] = [];
            for (let item of this.testiPrincipali)
                data["testiPrincipali"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.testiGiorni)) {
            data["testiGiorni"] = [];
            for (let item of this.testiGiorni)
                data["testiGiorni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.testiNote)) {
            data["testiNote"] = [];
            for (let item of this.testiNote)
                data["testiNote"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.itinerario)) {
            data["itinerario"] = [];
            for (let item of this.itinerario)
                data["itinerario"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item ? item.toJSON() : null as any);
        }
        data["partenzePerFiltri"] = this.partenzePerFiltri ? this.partenzePerFiltri.toJSON() : null as any;
        if (Array.isArray(this.regolePacchetto)) {
            data["regolePacchetto"] = [];
            for (let item of this.regolePacchetto)
                data["regolePacchetto"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item ? item.toJSON() : null as any);
        }
        data["providerContact"] = this.providerContact ? this.providerContact.toJSON() : null as any;
        if (Array.isArray(this.departureAirports)) {
            data["departureAirports"] = [];
            for (let item of this.departureAirports)
                data["departureAirports"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.airlines)) {
            data["airlines"] = [];
            for (let item of this.airlines)
                data["airlines"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServiceData {
    id?: string;
    servizioID?: number;
    interno?: boolean;
    prezzoBase?: number | null;
    nome?: string | null;
    sottoTitolo?: string | null;
    stringaRicerca?: string | null;
    indirizzo?: string | null;
    altroLuogo?: boolean;
    luogo?: string | null;
    destinazioneID?: number | null;
    cover?: string | null;
    durata?: ServiceDuration | null;
    stelle?: number | null;
    urlName?: string | null;
    mappa?: Mappa | null;
    attributiFiltro?: number[] | null;
    haAttributiTestata?: boolean;
    haCategoria?: boolean;
    categoria?: string | null;
    haNuovo?: boolean;
    nuovo?: string | null;
    haVantaggi?: boolean;
    vantaggi?: string | null;
    haServizi?: boolean;
    inRistrutturazione?: string | null;
    tipoServizio?: ETipoServizio;
    popolarita?: number | null;
    haAttributiNoleggi?: boolean;
    attributiNoleggi?: ElencoAttributiNoleggio[] | null;
    tappe?: (string | null)[] | null;
    luoghi?: number[] | null;
    date?: ServiceDeparture[] | null;
    attributi?: ServiceAttribute[] | null;
    preferito?: boolean;
    prezzi?: ServizioSearch | null;
    testiPrincipali?: TestoCompleto[] | null;
    testiGiorni?: TestoCompleto[] | null;
    testiNote?: TestoCompleto[] | null;
    itinerario?: (ServiceItineraryStep | null)[] | null;
    immagini?: ServiceImage[] | null;
    partenzePerFiltri?: ServiceDepartureFilterValues | null;
    regolePacchetto?: ServizioRegolaScontoPacchetto[] | null;
    tipologie?: TipologieServiziItinerario[] | null;
    providerContact?: ServiceProviderContact;
    departureAirports?: PackageDepartureAirports[] | null;
    airlines?: PackageAirlines[] | null;
}

export class ServiceDuration implements IServiceDuration {
    giorni?: number;
    notti?: number;

    constructor(data?: IServiceDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
        }
    }

    static fromJS(data: any): ServiceDuration {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorni"] = this.giorni !== undefined ? this.giorni : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        return data;
    }
}

export interface IServiceDuration {
    giorni?: number;
    notti?: number;
}

export class Mappa implements IMappa {
    mappaID?: number;
    tabella!: string;
    entitaID?: number;
    latitudine?: number | null;
    longitudine?: number | null;
    provider?: number | null;
    zoom?: number | null;
    layout?: number | null;

    constructor(data?: IMappa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mappaID = _data["mappaID"] !== undefined ? _data["mappaID"] : null as any;
            this.tabella = _data["tabella"] !== undefined ? _data["tabella"] : null as any;
            this.entitaID = _data["entitaID"] !== undefined ? _data["entitaID"] : null as any;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : null as any;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : null as any;
            this.provider = _data["provider"] !== undefined ? _data["provider"] : null as any;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : null as any;
            this.layout = _data["layout"] !== undefined ? _data["layout"] : null as any;
        }
    }

    static fromJS(data: any): Mappa {
        data = typeof data === 'object' ? data : {};
        let result = new Mappa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappaID"] = this.mappaID !== undefined ? this.mappaID : null as any;
        data["tabella"] = this.tabella !== undefined ? this.tabella : null as any;
        data["entitaID"] = this.entitaID !== undefined ? this.entitaID : null as any;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : null as any;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : null as any;
        data["provider"] = this.provider !== undefined ? this.provider : null as any;
        data["zoom"] = this.zoom !== undefined ? this.zoom : null as any;
        data["layout"] = this.layout !== undefined ? this.layout : null as any;
        return data;
    }
}

export interface IMappa {
    mappaID?: number;
    tabella: string;
    entitaID?: number;
    latitudine?: number | null;
    longitudine?: number | null;
    provider?: number | null;
    zoom?: number | null;
    layout?: number | null;
}

export enum ETipoServizio {
    TrasferimentiEVisite = "TrasferimentiEVisite",
    NoleggiAuto = "NoleggiAuto",
    SelfDrive = "SelfDrive",
    TourECrociere = "TourECrociere",
    Hotel = "Hotel",
    KitViaggio = "KitViaggio",
    Pacchetti = "Pacchetti",
    Voli = "Voli",
    KitViaggioOLD = "KitViaggioOLD",
    ItinerariConsigliati = "ItinerariConsigliati",
    PacchettiDinamici = "PacchettiDinamici",
    PacchettiCatalogo = "PacchettiCatalogo",
}

export class ElencoAttributiNoleggio implements IElencoAttributiNoleggio {
    titolo?: string | null;
    attributiNoleggio?: AttributoNoleggio[] | null;

    constructor(data?: IElencoAttributiNoleggio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            if (Array.isArray(_data["attributiNoleggio"])) {
                this.attributiNoleggio = [] as any;
                for (let item of _data["attributiNoleggio"])
                    this.attributiNoleggio!.push(AttributoNoleggio.fromJS(item));
            }
            else {
                this.attributiNoleggio = null as any;
            }
        }
    }

    static fromJS(data: any): ElencoAttributiNoleggio {
        data = typeof data === 'object' ? data : {};
        let result = new ElencoAttributiNoleggio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        if (Array.isArray(this.attributiNoleggio)) {
            data["attributiNoleggio"] = [];
            for (let item of this.attributiNoleggio)
                data["attributiNoleggio"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IElencoAttributiNoleggio {
    titolo?: string | null;
    attributiNoleggio?: AttributoNoleggio[] | null;
}

export class AttributoNoleggio implements IAttributoNoleggio {
    icona?: string | null;
    nome?: string | null;
    valore?: string | null;
    titolo?: string | null;

    constructor(data?: IAttributoNoleggio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icona = _data["icona"] !== undefined ? _data["icona"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
        }
    }

    static fromJS(data: any): AttributoNoleggio {
        data = typeof data === 'object' ? data : {};
        let result = new AttributoNoleggio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icona"] = this.icona !== undefined ? this.icona : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        return data;
    }
}

export interface IAttributoNoleggio {
    icona?: string | null;
    nome?: string | null;
    valore?: string | null;
    titolo?: string | null;
}

export class ServiceDeparture implements IServiceDeparture {
    anno?: number;
    mese?: number;
    annoSuccessivo?: boolean;
    tag?: number;
    giorni?: Date[] | null;
    flags?: EPartenzaFlags;
    prezzi?: PartenzaPrezzo[] | null;

    constructor(data?: IServiceDeparture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anno = _data["anno"] !== undefined ? _data["anno"] : null as any;
            this.mese = _data["mese"] !== undefined ? _data["mese"] : null as any;
            this.annoSuccessivo = _data["annoSuccessivo"] !== undefined ? _data["annoSuccessivo"] : null as any;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : null as any;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(new Date(item));
            }
            else {
                this.giorni = null as any;
            }
            this.flags = _data["flags"] !== undefined ? _data["flags"] : null as any;
            if (Array.isArray(_data["prezzi"])) {
                this.prezzi = [] as any;
                for (let item of _data["prezzi"])
                    this.prezzi!.push(PartenzaPrezzo.fromJS(item));
            }
            else {
                this.prezzi = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceDeparture {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeparture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anno"] = this.anno !== undefined ? this.anno : null as any;
        data["mese"] = this.mese !== undefined ? this.mese : null as any;
        data["annoSuccessivo"] = this.annoSuccessivo !== undefined ? this.annoSuccessivo : null as any;
        data["tag"] = this.tag !== undefined ? this.tag : null as any;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item.toISOString());
        }
        data["flags"] = this.flags !== undefined ? this.flags : null as any;
        if (Array.isArray(this.prezzi)) {
            data["prezzi"] = [];
            for (let item of this.prezzi)
                data["prezzi"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServiceDeparture {
    anno?: number;
    mese?: number;
    annoSuccessivo?: boolean;
    tag?: number;
    giorni?: Date[] | null;
    flags?: EPartenzaFlags;
    prezzi?: PartenzaPrezzo[] | null;
}

export enum EPartenzaFlags {
    Nessuno = "Nessuno",
    Garantita = "Garantita",
    InItaliano = "InItaliano",
    SuRichiesta = "SuRichiesta",
    InInglese = "InInglese",
    InTedesco = "InTedesco",
    InFrancese = "InFrancese",
    InSpagnolo = "InSpagnolo",
    InOlandese = "InOlandese",
}

export class PartenzaPrezzo implements IPartenzaPrezzo {
    id?: number;
    departureID?: number;
    departureAirport?: string | null;
    price?: number;
    updatedAt?: Date | null;
    expiresAt?: Date | null;

    constructor(data?: IPartenzaPrezzo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : null as any;
            this.departureAirport = _data["departureAirport"] !== undefined ? _data["departureAirport"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : null as any;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PartenzaPrezzo {
        data = typeof data === 'object' ? data : {};
        let result = new PartenzaPrezzo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["departureID"] = this.departureID !== undefined ? this.departureID : null as any;
        data["departureAirport"] = this.departureAirport !== undefined ? this.departureAirport : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null as any;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : null as any;
        return data;
    }
}

export interface IPartenzaPrezzo {
    id?: number;
    departureID?: number;
    departureAirport?: string | null;
    price?: number;
    updatedAt?: Date | null;
    expiresAt?: Date | null;
}

export class ServiceAttribute implements IServiceAttribute {
    tipoID?: number;
    nomeTipo?: string | null;
    valori?: string[] | null;

    constructor(data?: IServiceAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoID = _data["tipoID"] !== undefined ? _data["tipoID"] : null as any;
            this.nomeTipo = _data["nomeTipo"] !== undefined ? _data["nomeTipo"] : null as any;
            if (Array.isArray(_data["valori"])) {
                this.valori = [] as any;
                for (let item of _data["valori"])
                    this.valori!.push(item);
            }
            else {
                this.valori = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoID"] = this.tipoID !== undefined ? this.tipoID : null as any;
        data["nomeTipo"] = this.nomeTipo !== undefined ? this.nomeTipo : null as any;
        if (Array.isArray(this.valori)) {
            data["valori"] = [];
            for (let item of this.valori)
                data["valori"].push(item);
        }
        return data;
    }
}

export interface IServiceAttribute {
    tipoID?: number;
    nomeTipo?: string | null;
    valori?: string[] | null;
}

export class ServizioSearch implements IServizioSearch {
    id?: string | null;
    codice?: string | null;
    nonMappato?: boolean;
    servizioID?: number;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    disponibilitaPrezzoMinimo?: EStatoDisponibilita;
    abbinamentiTipologie?: AbbinamentoTipologie[] | null;
    hasAvailable?: boolean;
    isOpen?: boolean;
    drilledDown?: boolean;
    bests?: Best[] | null;
    hasExpired?: boolean;
    suppliers?: number[] | null;

    constructor(data?: IServizioSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nonMappato = _data["nonMappato"] !== undefined ? _data["nonMappato"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : null as any;
            this.prezzoPienoValuta = _data["prezzoPienoValuta"] !== undefined ? _data["prezzoPienoValuta"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.disponibilitaPrezzoMinimo = _data["disponibilitaPrezzoMinimo"] !== undefined ? _data["disponibilitaPrezzoMinimo"] : null as any;
            if (Array.isArray(_data["abbinamentiTipologie"])) {
                this.abbinamentiTipologie = [] as any;
                for (let item of _data["abbinamentiTipologie"])
                    this.abbinamentiTipologie!.push(AbbinamentoTipologie.fromJS(item));
            }
            else {
                this.abbinamentiTipologie = null as any;
            }
            this.hasAvailable = _data["hasAvailable"] !== undefined ? _data["hasAvailable"] : null as any;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : null as any;
            this.drilledDown = _data["drilledDown"] !== undefined ? _data["drilledDown"] : null as any;
            if (Array.isArray(_data["bests"])) {
                this.bests = [] as any;
                for (let item of _data["bests"])
                    this.bests!.push(Best.fromJS(item));
            }
            else {
                this.bests = null as any;
            }
            this.hasExpired = _data["hasExpired"] !== undefined ? _data["hasExpired"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(item);
            }
            else {
                this.suppliers = null as any;
            }
        }
    }

    static fromJS(data: any): ServizioSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nonMappato"] = this.nonMappato !== undefined ? this.nonMappato : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : null as any;
        data["prezzoPienoValuta"] = this.prezzoPienoValuta !== undefined ? this.prezzoPienoValuta : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["disponibilitaPrezzoMinimo"] = this.disponibilitaPrezzoMinimo !== undefined ? this.disponibilitaPrezzoMinimo : null as any;
        if (Array.isArray(this.abbinamentiTipologie)) {
            data["abbinamentiTipologie"] = [];
            for (let item of this.abbinamentiTipologie)
                data["abbinamentiTipologie"].push(item ? item.toJSON() : null as any);
        }
        data["hasAvailable"] = this.hasAvailable !== undefined ? this.hasAvailable : null as any;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : null as any;
        data["drilledDown"] = this.drilledDown !== undefined ? this.drilledDown : null as any;
        if (Array.isArray(this.bests)) {
            data["bests"] = [];
            for (let item of this.bests)
                data["bests"].push(item ? item.toJSON() : null as any);
        }
        data["hasExpired"] = this.hasExpired !== undefined ? this.hasExpired : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item);
        }
        return data;
    }
}

export interface IServizioSearch {
    id?: string | null;
    codice?: string | null;
    nonMappato?: boolean;
    servizioID?: number;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    disponibilitaPrezzoMinimo?: EStatoDisponibilita;
    abbinamentiTipologie?: AbbinamentoTipologie[] | null;
    hasAvailable?: boolean;
    isOpen?: boolean;
    drilledDown?: boolean;
    bests?: Best[] | null;
    hasExpired?: boolean;
    suppliers?: number[] | null;
}

export enum EStatoDisponibilita {
    NonDisponibile = "NonDisponibile",
    SuRichiesta = "SuRichiesta",
    Disponibile = "Disponibile",
    DaVerificare = "DaVerificare",
    DisponibileFreesale = "DisponibileFreesale",
    NonDisponibileNoMatchRegola = "NonDisponibileNoMatchRegola",
    Indeterminato = "Indeterminato",
}

export class AbbinamentoTipologie implements IAbbinamentoTipologie {
    gruppoID?: number;
    nomeGruppo?: string;
    nomiPax?: string;
    macroTipologie?: GruppoMacroTipologie[];

    constructor(data?: IAbbinamentoTipologie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : null as any;
            this.nomeGruppo = _data["nomeGruppo"] !== undefined ? _data["nomeGruppo"] : null as any;
            this.nomiPax = _data["nomiPax"] !== undefined ? _data["nomiPax"] : null as any;
            if (Array.isArray(_data["macroTipologie"])) {
                this.macroTipologie = [] as any;
                for (let item of _data["macroTipologie"])
                    this.macroTipologie!.push(GruppoMacroTipologie.fromJS(item));
            }
            else {
                this.macroTipologie = null as any;
            }
        }
    }

    static fromJS(data: any): AbbinamentoTipologie {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoTipologie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : null as any;
        data["nomeGruppo"] = this.nomeGruppo !== undefined ? this.nomeGruppo : null as any;
        data["nomiPax"] = this.nomiPax !== undefined ? this.nomiPax : null as any;
        if (Array.isArray(this.macroTipologie)) {
            data["macroTipologie"] = [];
            for (let item of this.macroTipologie)
                data["macroTipologie"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAbbinamentoTipologie {
    gruppoID?: number;
    nomeGruppo?: string;
    nomiPax?: string;
    macroTipologie?: GruppoMacroTipologie[];
}

export class GruppoMacroTipologie implements IGruppoMacroTipologie {
    nome?: string | null;
    tipologie?: TipologiaSearch[];

    constructor(data?: IGruppoMacroTipologie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(TipologiaSearch.fromJS(item));
            }
            else {
                this.tipologie = null as any;
            }
        }
    }

    static fromJS(data: any): GruppoMacroTipologie {
        data = typeof data === 'object' ? data : {};
        let result = new GruppoMacroTipologie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGruppoMacroTipologie {
    nome?: string | null;
    tipologie?: TipologiaSearch[];
}

export class TipologiaSearch implements ITipologiaSearch {
    id?: string | null;
    sourceMainCacheID?: string | null;
    sourceResultItemID?: number;
    sourceResultID?: number;
    supplierID?: number;
    fornitore?: string | null;
    gruppoID?: number;
    nome?: string | null;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    supplementi?: Supplemento[] | null;
    partenze?: PartenzaSearch[] | null;
    hashcode?: string | null;
    fullContent?: boolean;
    hashMacro?: string | null;
    score?: number;

    constructor(data?: ITipologiaSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sourceMainCacheID = _data["sourceMainCacheID"] !== undefined ? _data["sourceMainCacheID"] : null as any;
            this.sourceResultItemID = _data["sourceResultItemID"] !== undefined ? _data["sourceResultItemID"] : null as any;
            this.sourceResultID = _data["sourceResultID"] !== undefined ? _data["sourceResultID"] : null as any;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : null as any;
            this.prezzoPienoValuta = _data["prezzoPienoValuta"] !== undefined ? _data["prezzoPienoValuta"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : null as any;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : null as any;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(Supplemento.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(PartenzaSearch.fromJS(item));
            }
            else {
                this.partenze = null as any;
            }
            this.hashcode = _data["hashcode"] !== undefined ? _data["hashcode"] : null as any;
            this.fullContent = _data["fullContent"] !== undefined ? _data["fullContent"] : null as any;
            this.hashMacro = _data["hashMacro"] !== undefined ? _data["hashMacro"] : null as any;
            this.score = _data["score"] !== undefined ? _data["score"] : null as any;
        }
    }

    static fromJS(data: any): TipologiaSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TipologiaSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sourceMainCacheID"] = this.sourceMainCacheID !== undefined ? this.sourceMainCacheID : null as any;
        data["sourceResultItemID"] = this.sourceResultItemID !== undefined ? this.sourceResultItemID : null as any;
        data["sourceResultID"] = this.sourceResultID !== undefined ? this.sourceResultID : null as any;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : null as any;
        data["prezzoPienoValuta"] = this.prezzoPienoValuta !== undefined ? this.prezzoPienoValuta : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : null as any;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : null as any;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item ? item.toJSON() : null as any);
        }
        data["hashcode"] = this.hashcode !== undefined ? this.hashcode : null as any;
        data["fullContent"] = this.fullContent !== undefined ? this.fullContent : null as any;
        data["hashMacro"] = this.hashMacro !== undefined ? this.hashMacro : null as any;
        data["score"] = this.score !== undefined ? this.score : null as any;
        return data;
    }
}

export interface ITipologiaSearch {
    id?: string | null;
    sourceMainCacheID?: string | null;
    sourceResultItemID?: number;
    sourceResultID?: number;
    supplierID?: number;
    fornitore?: string | null;
    gruppoID?: number;
    nome?: string | null;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    supplementi?: Supplemento[] | null;
    partenze?: PartenzaSearch[] | null;
    hashcode?: string | null;
    fullContent?: boolean;
    hashMacro?: string | null;
    score?: number;
}

export class Supplemento implements ISupplemento {
    id?: number;
    obbligatorio?: boolean;
    percentuale?: boolean;
    alternative?: SupplementoAlternativa[] | null;

    constructor(data?: ISupplemento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.obbligatorio = _data["obbligatorio"] !== undefined ? _data["obbligatorio"] : null as any;
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : null as any;
            if (Array.isArray(_data["alternative"])) {
                this.alternative = [] as any;
                for (let item of _data["alternative"])
                    this.alternative!.push(SupplementoAlternativa.fromJS(item));
            }
            else {
                this.alternative = null as any;
            }
        }
    }

    static fromJS(data: any): Supplemento {
        data = typeof data === 'object' ? data : {};
        let result = new Supplemento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["obbligatorio"] = this.obbligatorio !== undefined ? this.obbligatorio : null as any;
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : null as any;
        if (Array.isArray(this.alternative)) {
            data["alternative"] = [];
            for (let item of this.alternative)
                data["alternative"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISupplemento {
    id?: number;
    obbligatorio?: boolean;
    percentuale?: boolean;
    alternative?: SupplementoAlternativa[] | null;
}

export class SupplementoAlternativa implements ISupplementoAlternativa {
    id?: number;
    nome?: string;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;

    constructor(data?: ISupplementoAlternativa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : null as any;
            this.prezzoPienoValuta = _data["prezzoPienoValuta"] !== undefined ? _data["prezzoPienoValuta"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : null as any;
        }
    }

    static fromJS(data: any): SupplementoAlternativa {
        data = typeof data === 'object' ? data : {};
        let result = new SupplementoAlternativa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : null as any;
        data["prezzoPienoValuta"] = this.prezzoPienoValuta !== undefined ? this.prezzoPienoValuta : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : null as any;
        return data;
    }
}

export interface ISupplementoAlternativa {
    id?: number;
    nome?: string;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;
}

export class PartenzaSearch implements IPartenzaSearch {
    sourceReferenceID?: number;
    data?: Date;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    supplementi?: Supplemento[] | null;
    garantita?: boolean;
    italiano?: boolean;
    inglese?: boolean;
    francese?: boolean;
    tedesco?: boolean;
    spagnolo?: boolean;
    olandese?: boolean;

    constructor(data?: IPartenzaSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceReferenceID = _data["sourceReferenceID"] !== undefined ? _data["sourceReferenceID"] : null as any;
            this.data = _data["data"] ? new Date(_data["data"].toString()) : null as any;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : null as any;
            this.prezzoPienoValuta = _data["prezzoPienoValuta"] !== undefined ? _data["prezzoPienoValuta"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(Supplemento.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            this.garantita = _data["garantita"] !== undefined ? _data["garantita"] : null as any;
            this.italiano = _data["italiano"] !== undefined ? _data["italiano"] : null as any;
            this.inglese = _data["inglese"] !== undefined ? _data["inglese"] : null as any;
            this.francese = _data["francese"] !== undefined ? _data["francese"] : null as any;
            this.tedesco = _data["tedesco"] !== undefined ? _data["tedesco"] : null as any;
            this.spagnolo = _data["spagnolo"] !== undefined ? _data["spagnolo"] : null as any;
            this.olandese = _data["olandese"] !== undefined ? _data["olandese"] : null as any;
        }
    }

    static fromJS(data: any): PartenzaSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PartenzaSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceReferenceID"] = this.sourceReferenceID !== undefined ? this.sourceReferenceID : null as any;
        data["data"] = this.data ? this.data.toISOString() : null as any;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : null as any;
        data["prezzoPienoValuta"] = this.prezzoPienoValuta !== undefined ? this.prezzoPienoValuta : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        data["garantita"] = this.garantita !== undefined ? this.garantita : null as any;
        data["italiano"] = this.italiano !== undefined ? this.italiano : null as any;
        data["inglese"] = this.inglese !== undefined ? this.inglese : null as any;
        data["francese"] = this.francese !== undefined ? this.francese : null as any;
        data["tedesco"] = this.tedesco !== undefined ? this.tedesco : null as any;
        data["spagnolo"] = this.spagnolo !== undefined ? this.spagnolo : null as any;
        data["olandese"] = this.olandese !== undefined ? this.olandese : null as any;
        return data;
    }
}

export interface IPartenzaSearch {
    sourceReferenceID?: number;
    data?: Date;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    supplementi?: Supplemento[] | null;
    garantita?: boolean;
    italiano?: boolean;
    inglese?: boolean;
    francese?: boolean;
    tedesco?: boolean;
    spagnolo?: boolean;
    olandese?: boolean;
}

export class Best implements IBest {
    attributoID?: number | null;
    nomeMacro?: string | null;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    haPartenze?: boolean;
    disponibilita?: EStatoDisponibilita;
    gruppo?: string | null;
    chiave?: string;
    acquistabile?: boolean;
    serviceSearchDataBuffer?: string | null;
    nomeMacroDescID?: number | null;
    gruppoDescID?: number | null;

    constructor(data?: IBest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributoID = _data["attributoID"] !== undefined ? _data["attributoID"] : null as any;
            this.nomeMacro = _data["nomeMacro"] !== undefined ? _data["nomeMacro"] : null as any;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : null as any;
            this.prezzoPienoValuta = _data["prezzoPienoValuta"] !== undefined ? _data["prezzoPienoValuta"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : null as any;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : null as any;
            this.haPartenze = _data["haPartenze"] !== undefined ? _data["haPartenze"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            this.gruppo = _data["gruppo"] !== undefined ? _data["gruppo"] : null as any;
            this.chiave = _data["chiave"] !== undefined ? _data["chiave"] : null as any;
            this.acquistabile = _data["acquistabile"] !== undefined ? _data["acquistabile"] : null as any;
            this.serviceSearchDataBuffer = _data["serviceSearchDataBuffer"] !== undefined ? _data["serviceSearchDataBuffer"] : null as any;
            this.nomeMacroDescID = _data["nomeMacroDescID"] !== undefined ? _data["nomeMacroDescID"] : null as any;
            this.gruppoDescID = _data["gruppoDescID"] !== undefined ? _data["gruppoDescID"] : null as any;
        }
    }

    static fromJS(data: any): Best {
        data = typeof data === 'object' ? data : {};
        let result = new Best();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributoID"] = this.attributoID !== undefined ? this.attributoID : null as any;
        data["nomeMacro"] = this.nomeMacro !== undefined ? this.nomeMacro : null as any;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : null as any;
        data["prezzoPienoValuta"] = this.prezzoPienoValuta !== undefined ? this.prezzoPienoValuta : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : null as any;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : null as any;
        data["haPartenze"] = this.haPartenze !== undefined ? this.haPartenze : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        data["gruppo"] = this.gruppo !== undefined ? this.gruppo : null as any;
        data["chiave"] = this.chiave !== undefined ? this.chiave : null as any;
        data["acquistabile"] = this.acquistabile !== undefined ? this.acquistabile : null as any;
        data["serviceSearchDataBuffer"] = this.serviceSearchDataBuffer !== undefined ? this.serviceSearchDataBuffer : null as any;
        data["nomeMacroDescID"] = this.nomeMacroDescID !== undefined ? this.nomeMacroDescID : null as any;
        data["gruppoDescID"] = this.gruppoDescID !== undefined ? this.gruppoDescID : null as any;
        return data;
    }
}

export interface IBest {
    attributoID?: number | null;
    nomeMacro?: string | null;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    haPartenze?: boolean;
    disponibilita?: EStatoDisponibilita;
    gruppo?: string | null;
    chiave?: string;
    acquistabile?: boolean;
    serviceSearchDataBuffer?: string | null;
    nomeMacroDescID?: number | null;
    gruppoDescID?: number | null;
}

export class TestoCompleto implements ITestoCompleto {
    testoID?: number;
    lingua?: ELingua;
    tipoTesto?: ETipoTesto;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    giorno?: number;
    ordine?: number;
    tradottoAutomaticamente?: boolean;
    generatoAI?: boolean;
    allegati?: TestoCompletoAllegato[] | null;

    constructor(data?: ITestoCompleto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testoID = _data["testoID"] !== undefined ? _data["testoID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.tipoTesto = _data["tipoTesto"] !== undefined ? _data["tipoTesto"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.tradottoAutomaticamente = _data["tradottoAutomaticamente"] !== undefined ? _data["tradottoAutomaticamente"] : null as any;
            this.generatoAI = _data["generatoAI"] !== undefined ? _data["generatoAI"] : null as any;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(TestoCompletoAllegato.fromJS(item));
            }
            else {
                this.allegati = null as any;
            }
        }
    }

    static fromJS(data: any): TestoCompleto {
        data = typeof data === 'object' ? data : {};
        let result = new TestoCompleto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoID"] = this.testoID !== undefined ? this.testoID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["tipoTesto"] = this.tipoTesto !== undefined ? this.tipoTesto : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["sunto"] = this.sunto !== undefined ? this.sunto : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["tradottoAutomaticamente"] = this.tradottoAutomaticamente !== undefined ? this.tradottoAutomaticamente : null as any;
        data["generatoAI"] = this.generatoAI !== undefined ? this.generatoAI : null as any;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITestoCompleto {
    testoID?: number;
    lingua?: ELingua;
    tipoTesto?: ETipoTesto;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    giorno?: number;
    ordine?: number;
    tradottoAutomaticamente?: boolean;
    generatoAI?: boolean;
    allegati?: TestoCompletoAllegato[] | null;
}

export enum ETipoTesto {
    Articolo = "Articolo",
    ArticoloTraducibile = "ArticoloTraducibile",
    TestoFornitore = "TestoFornitore",
}

export class TestoCompletoAllegato implements ITestoCompletoAllegato {
    id?: number;
    nome?: string | null;

    constructor(data?: ITestoCompletoAllegato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): TestoCompletoAllegato {
        data = typeof data === 'object' ? data : {};
        let result = new TestoCompletoAllegato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface ITestoCompletoAllegato {
    id?: number;
    nome?: string | null;
}

export class ServiceItineraryStep implements IServiceItineraryStep {
    luogoID?: number;
    luogo?: string | null;
    latitudine?: number;
    longitudine?: number;
    notti?: number;
    tipoTrasporto?: ETipoTrasporto;
    ordine?: number;
    giorno?: number;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;

    constructor(data?: IServiceItineraryStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : null as any;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            this.tipoTrasporto = _data["tipoTrasporto"] !== undefined ? _data["tipoTrasporto"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : null as any;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : null as any;
            this.compagniaAerea2 = _data["compagniaAerea2"] !== undefined ? _data["compagniaAerea2"] : null as any;
            this.classe2 = _data["classe2"] !== undefined ? _data["classe2"] : null as any;
            this.cambioHotel = _data["cambioHotel"] !== undefined ? _data["cambioHotel"] : null as any;
        }
    }

    static fromJS(data: any): ServiceItineraryStep {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceItineraryStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : null as any;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        data["tipoTrasporto"] = this.tipoTrasporto !== undefined ? this.tipoTrasporto : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : null as any;
        data["classe"] = this.classe !== undefined ? this.classe : null as any;
        data["compagniaAerea2"] = this.compagniaAerea2 !== undefined ? this.compagniaAerea2 : null as any;
        data["classe2"] = this.classe2 !== undefined ? this.classe2 : null as any;
        data["cambioHotel"] = this.cambioHotel !== undefined ? this.cambioHotel : null as any;
        return data;
    }
}

export interface IServiceItineraryStep {
    luogoID?: number;
    luogo?: string | null;
    latitudine?: number;
    longitudine?: number;
    notti?: number;
    tipoTrasporto?: ETipoTrasporto;
    ordine?: number;
    giorno?: number;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;
}

export enum ETipoTrasporto {
    Aereo = "Aereo",
    Auto = "Auto",
    Traghetto = "Traghetto",
    Indefinito = "Indefinito",
    Treno = "Treno",
    Pullman = "Pullman",
}

export class ServiceImage implements IServiceImage {
    url?: string | null;
    title?: string | null;

    constructor(data?: IServiceImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): ServiceImage {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export interface IServiceImage {
    url?: string | null;
    title?: string | null;
}

export class ServiceDepartureFilterValues implements IServiceDepartureFilterValues {
    dataMinima?: number | null;
    dataMassima?: number | null;
    dateValide?: number[] | null;
    giornaliero?: boolean;

    constructor(data?: IServiceDepartureFilterValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMinima = _data["dataMinima"] !== undefined ? _data["dataMinima"] : null as any;
            this.dataMassima = _data["dataMassima"] !== undefined ? _data["dataMassima"] : null as any;
            if (Array.isArray(_data["dateValide"])) {
                this.dateValide = [] as any;
                for (let item of _data["dateValide"])
                    this.dateValide!.push(item);
            }
            else {
                this.dateValide = null as any;
            }
            this.giornaliero = _data["giornaliero"] !== undefined ? _data["giornaliero"] : null as any;
        }
    }

    static fromJS(data: any): ServiceDepartureFilterValues {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDepartureFilterValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMinima"] = this.dataMinima !== undefined ? this.dataMinima : null as any;
        data["dataMassima"] = this.dataMassima !== undefined ? this.dataMassima : null as any;
        if (Array.isArray(this.dateValide)) {
            data["dateValide"] = [];
            for (let item of this.dateValide)
                data["dateValide"].push(item);
        }
        data["giornaliero"] = this.giornaliero !== undefined ? this.giornaliero : null as any;
        return data;
    }
}

export interface IServiceDepartureFilterValues {
    dataMinima?: number | null;
    dataMassima?: number | null;
    dateValide?: number[] | null;
    giornaliero?: boolean;
}

export class ServizioRegolaScontoPacchetto implements IServizioRegolaScontoPacchetto {
    id?: number;
    servizioID?: number;
    itinerarioID?: number | null;
    servizioScontoID?: number | null;
    prenotaDal?: Date | null;
    prenotaAl?: Date | null;
    partenzaDal?: Date | null;
    partenzaAl?: Date | null;
    scontoServiziTerra?: number;
    scontoQuote?: number;
    scontoBloccaPrezzo?: number;
    nome?: string | null;
    ordine?: number;

    constructor(data?: IServizioRegolaScontoPacchetto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : null as any;
            this.servizioScontoID = _data["servizioScontoID"] !== undefined ? _data["servizioScontoID"] : null as any;
            this.prenotaDal = _data["prenotaDal"] ? new Date(_data["prenotaDal"].toString()) : null as any;
            this.prenotaAl = _data["prenotaAl"] ? new Date(_data["prenotaAl"].toString()) : null as any;
            this.partenzaDal = _data["partenzaDal"] ? new Date(_data["partenzaDal"].toString()) : null as any;
            this.partenzaAl = _data["partenzaAl"] ? new Date(_data["partenzaAl"].toString()) : null as any;
            this.scontoServiziTerra = _data["scontoServiziTerra"] !== undefined ? _data["scontoServiziTerra"] : null as any;
            this.scontoQuote = _data["scontoQuote"] !== undefined ? _data["scontoQuote"] : null as any;
            this.scontoBloccaPrezzo = _data["scontoBloccaPrezzo"] !== undefined ? _data["scontoBloccaPrezzo"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
        }
    }

    static fromJS(data: any): ServizioRegolaScontoPacchetto {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioRegolaScontoPacchetto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : null as any;
        data["servizioScontoID"] = this.servizioScontoID !== undefined ? this.servizioScontoID : null as any;
        data["prenotaDal"] = this.prenotaDal ? this.prenotaDal.toISOString() : null as any;
        data["prenotaAl"] = this.prenotaAl ? this.prenotaAl.toISOString() : null as any;
        data["partenzaDal"] = this.partenzaDal ? this.partenzaDal.toISOString() : null as any;
        data["partenzaAl"] = this.partenzaAl ? this.partenzaAl.toISOString() : null as any;
        data["scontoServiziTerra"] = this.scontoServiziTerra !== undefined ? this.scontoServiziTerra : null as any;
        data["scontoQuote"] = this.scontoQuote !== undefined ? this.scontoQuote : null as any;
        data["scontoBloccaPrezzo"] = this.scontoBloccaPrezzo !== undefined ? this.scontoBloccaPrezzo : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        return data;
    }
}

export interface IServizioRegolaScontoPacchetto {
    id?: number;
    servizioID?: number;
    itinerarioID?: number | null;
    servizioScontoID?: number | null;
    prenotaDal?: Date | null;
    prenotaAl?: Date | null;
    partenzaDal?: Date | null;
    partenzaAl?: Date | null;
    scontoServiziTerra?: number;
    scontoQuote?: number;
    scontoBloccaPrezzo?: number;
    nome?: string | null;
    ordine?: number;
}

export class TipologieServiziItinerario implements ITipologieServiziItinerario {
    tipologia?: string;
    giorni?: TipologieServiziItinerarioGiorno[];

    constructor(data?: ITipologieServiziItinerario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipologia = _data["tipologia"] !== undefined ? _data["tipologia"] : null as any;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(TipologieServiziItinerarioGiorno.fromJS(item));
            }
            else {
                this.giorni = null as any;
            }
        }
    }

    static fromJS(data: any): TipologieServiziItinerario {
        data = typeof data === 'object' ? data : {};
        let result = new TipologieServiziItinerario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologia"] = this.tipologia !== undefined ? this.tipologia : null as any;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITipologieServiziItinerario {
    tipologia?: string;
    giorni?: TipologieServiziItinerarioGiorno[];
}

export class TipologieServiziItinerarioGiorno implements ITipologieServiziItinerarioGiorno {
    luogo?: string;
    giorno?: number;
    durata?: number;
    servizi?: TipologieServiziItinerarioGiornoServizio[];

    constructor(data?: ITipologieServiziItinerarioGiorno) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(TipologieServiziItinerarioGiornoServizio.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
        }
    }

    static fromJS(data: any): TipologieServiziItinerarioGiorno {
        data = typeof data === 'object' ? data : {};
        let result = new TipologieServiziItinerarioGiorno();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["durata"] = this.durata !== undefined ? this.durata : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITipologieServiziItinerarioGiorno {
    luogo?: string;
    giorno?: number;
    durata?: number;
    servizi?: TipologieServiziItinerarioGiornoServizio[];
}

export class TipologieServiziItinerarioGiornoServizio implements ITipologieServiziItinerarioGiornoServizio {
    nome?: string;
    alternativa?: boolean;
    url?: string | null;

    constructor(data?: ITipologieServiziItinerarioGiornoServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.alternativa = _data["alternativa"] !== undefined ? _data["alternativa"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static fromJS(data: any): TipologieServiziItinerarioGiornoServizio {
        data = typeof data === 'object' ? data : {};
        let result = new TipologieServiziItinerarioGiornoServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["alternativa"] = this.alternativa !== undefined ? this.alternativa : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }
}

export interface ITipologieServiziItinerarioGiornoServizio {
    nome?: string;
    alternativa?: boolean;
    url?: string | null;
}

export class ServiceProviderContact implements IServiceProviderContact {
    contact?: Contatto | null;
    logo?: string | null;

    constructor(data?: IServiceProviderContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? Contatto.fromJS(_data["contact"]) : null as any;
            this.logo = _data["logo"] !== undefined ? _data["logo"] : null as any;
        }
    }

    static fromJS(data: any): ServiceProviderContact {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceProviderContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : null as any;
        data["logo"] = this.logo !== undefined ? this.logo : null as any;
        return data;
    }
}

export interface IServiceProviderContact {
    contact?: Contatto | null;
    logo?: string | null;
}

export class Contatto implements IContatto {
    contattoID?: number;
    contattoTipo?: ETipoContatto;
    luogoID?: number | null;
    nome?: string | null;
    cognome?: string | null;
    indirizzo?: string | null;
    civico?: string | null;
    cap?: string | null;
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
    note?: string | null;
    noFee?: boolean;
    categoriaContattoID?: number | null;
    titolo?: ETitolo;
    mansioneID?: number | null;
    abilitatoBookingVoli?: boolean;
    markupAdv?: number | null;
    indirizzoFatturazione?: string | null;
    luogoFatturazioneID?: number | null;
    capFatturazione?: string | null;
    civicoFatturazione?: string | null;
    eliminato?: boolean;
    lingua?: number | null;
    fatturazioneAlNetto?: boolean;

    constructor(data?: IContatto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.contattoTipo = _data["contattoTipo"] !== undefined ? _data["contattoTipo"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.noFee = _data["noFee"] !== undefined ? _data["noFee"] : null as any;
            this.categoriaContattoID = _data["categoriaContattoID"] !== undefined ? _data["categoriaContattoID"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.mansioneID = _data["mansioneID"] !== undefined ? _data["mansioneID"] : null as any;
            this.abilitatoBookingVoli = _data["abilitatoBookingVoli"] !== undefined ? _data["abilitatoBookingVoli"] : null as any;
            this.markupAdv = _data["markupAdv"] !== undefined ? _data["markupAdv"] : null as any;
            this.indirizzoFatturazione = _data["indirizzoFatturazione"] !== undefined ? _data["indirizzoFatturazione"] : null as any;
            this.luogoFatturazioneID = _data["luogoFatturazioneID"] !== undefined ? _data["luogoFatturazioneID"] : null as any;
            this.capFatturazione = _data["capFatturazione"] !== undefined ? _data["capFatturazione"] : null as any;
            this.civicoFatturazione = _data["civicoFatturazione"] !== undefined ? _data["civicoFatturazione"] : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.fatturazioneAlNetto = _data["fatturazioneAlNetto"] !== undefined ? _data["fatturazioneAlNetto"] : null as any;
        }
    }

    static fromJS(data: any): Contatto {
        data = typeof data === 'object' ? data : {};
        let result = new Contatto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["contattoTipo"] = this.contattoTipo !== undefined ? this.contattoTipo : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["civico"] = this.civico !== undefined ? this.civico : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["noFee"] = this.noFee !== undefined ? this.noFee : null as any;
        data["categoriaContattoID"] = this.categoriaContattoID !== undefined ? this.categoriaContattoID : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["mansioneID"] = this.mansioneID !== undefined ? this.mansioneID : null as any;
        data["abilitatoBookingVoli"] = this.abilitatoBookingVoli !== undefined ? this.abilitatoBookingVoli : null as any;
        data["markupAdv"] = this.markupAdv !== undefined ? this.markupAdv : null as any;
        data["indirizzoFatturazione"] = this.indirizzoFatturazione !== undefined ? this.indirizzoFatturazione : null as any;
        data["luogoFatturazioneID"] = this.luogoFatturazioneID !== undefined ? this.luogoFatturazioneID : null as any;
        data["capFatturazione"] = this.capFatturazione !== undefined ? this.capFatturazione : null as any;
        data["civicoFatturazione"] = this.civicoFatturazione !== undefined ? this.civicoFatturazione : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["fatturazioneAlNetto"] = this.fatturazioneAlNetto !== undefined ? this.fatturazioneAlNetto : null as any;
        return data;
    }
}

export interface IContatto {
    contattoID?: number;
    contattoTipo?: ETipoContatto;
    luogoID?: number | null;
    nome?: string | null;
    cognome?: string | null;
    indirizzo?: string | null;
    civico?: string | null;
    cap?: string | null;
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
    note?: string | null;
    noFee?: boolean;
    categoriaContattoID?: number | null;
    titolo?: ETitolo;
    mansioneID?: number | null;
    abilitatoBookingVoli?: boolean;
    markupAdv?: number | null;
    indirizzoFatturazione?: string | null;
    luogoFatturazioneID?: number | null;
    capFatturazione?: string | null;
    civicoFatturazione?: string | null;
    eliminato?: boolean;
    lingua?: number | null;
    fatturazioneAlNetto?: boolean;
}

export enum ETipoContatto {
    Fornitore = "Fornitore",
    Addetto = "Addetto",
    Agenzia = "Agenzia",
    UfficioFornitore = "UfficioFornitore",
    Produttore = "Produttore",
    TourOperator = "TourOperator",
    GruppiAgenzie = "GruppiAgenzie",
    ContrattiAgenti = "ContrattiAgenti",
    Hotel = "Hotel",
    Corrieri = "Corrieri",
    CompagnieAeree = "CompagnieAeree",
    FornitoreIndiretto = "FornitoreIndiretto",
    Giornali = "Giornali",
    ClienteDiretto = "ClienteDiretto",
    Appartamenti = "Appartamenti",
    AgenzieChiuse = "AgenzieChiuse",
    SottogruppiAgenzie = "SottogruppiAgenzie",
    FornitoreContabilita = "FornitoreContabilita",
    PuntoPickup = "PuntoPickup",
    ClienteContabilita = "ClienteContabilita",
}

export enum ETitolo {
    Signor = "Signor",
    Signora = "Signora",
    Bambina = "Bambina",
    Bambino = "Bambino",
    Dottor = "Dottor",
    Dottssa = "Dottssa",
    Sconosciuto = "Sconosciuto",
    Srl = "Srl",
    SpA = "SpA",
    Sas = "Sas",
    Snc = "Snc",
}

export class PackageDepartureAirports implements IPackageDepartureAirports {
    airportID?: number;
    airportCode?: string;
    airportName?: string;
    city?: number | null;

    constructor(data?: IPackageDepartureAirports) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airportID = _data["airportID"] !== undefined ? _data["airportID"] : null as any;
            this.airportCode = _data["airportCode"] !== undefined ? _data["airportCode"] : null as any;
            this.airportName = _data["airportName"] !== undefined ? _data["airportName"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
        }
    }

    static fromJS(data: any): PackageDepartureAirports {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDepartureAirports();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportID"] = this.airportID !== undefined ? this.airportID : null as any;
        data["airportCode"] = this.airportCode !== undefined ? this.airportCode : null as any;
        data["airportName"] = this.airportName !== undefined ? this.airportName : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        return data;
    }
}

export interface IPackageDepartureAirports {
    airportID?: number;
    airportCode?: string;
    airportName?: string;
    city?: number | null;
}

export class PackageAirlines implements IPackageAirlines {
    airlineID?: number;
    airlineCode?: string;
    airlineName?: string;

    constructor(data?: IPackageAirlines) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airlineID = _data["airlineID"] !== undefined ? _data["airlineID"] : null as any;
            this.airlineCode = _data["airlineCode"] !== undefined ? _data["airlineCode"] : null as any;
            this.airlineName = _data["airlineName"] !== undefined ? _data["airlineName"] : null as any;
        }
    }

    static fromJS(data: any): PackageAirlines {
        data = typeof data === 'object' ? data : {};
        let result = new PackageAirlines();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineID"] = this.airlineID !== undefined ? this.airlineID : null as any;
        data["airlineCode"] = this.airlineCode !== undefined ? this.airlineCode : null as any;
        data["airlineName"] = this.airlineName !== undefined ? this.airlineName : null as any;
        return data;
    }
}

export interface IPackageAirlines {
    airlineID?: number;
    airlineCode?: string;
    airlineName?: string;
}

export class GetServiceRequest extends NaarGoRequest implements IGetServiceRequest {
    serviceId?: number;
    external?: boolean;
    requestedArticlesType?: ETipoArticoliRichiesti;

    constructor(data?: IGetServiceRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.external = _data["external"] !== undefined ? _data["external"] : null as any;
            this.requestedArticlesType = _data["requestedArticlesType"] !== undefined ? _data["requestedArticlesType"] : null as any;
        }
    }

    static override fromJS(data: any): GetServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["external"] = this.external !== undefined ? this.external : null as any;
        data["requestedArticlesType"] = this.requestedArticlesType !== undefined ? this.requestedArticlesType : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceRequest extends INaarGoRequest {
    serviceId?: number;
    external?: boolean;
    requestedArticlesType?: ETipoArticoliRichiesti;
}

export enum ETipoArticoliRichiesti {
    PreferTraducibili = "preferTraducibili",
    SoloTraducibili = "soloTraducibili",
    SoloCanonici = "soloCanonici",
    Tutti = "tutti",
}

export class GetTripResponse extends OkNaarGoResponse implements IGetTripResponse {
    trip?: NaarGoTripRow;

    constructor(data?: IGetTripResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trip = _data["trip"] ? NaarGoTripRow.fromJS(_data["trip"]) : null as any;
        }
    }

    static override fromJS(data: any): GetTripResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trip"] = this.trip ? this.trip.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripResponse extends IOkNaarGoResponse {
    trip?: NaarGoTripRow;
}

export class NaarGoTripRow implements INaarGoTripRow {
    id?: number;
    description?: string;
    departureDate?: Date;
    arrivalDate?: Date | null;
    destination?: string | null;
    status?: EStatoOffertaUtente | null;
    flights?: NaarGoTripFlightRow[] | null;
    steps?: NaarGoTripStepRow[] | null;
    notes?: NaarGoTripNotaRow[] | null;
    docs?: NaarGoTripDocRow[] | null;
    vouchers?: NaarGoTripVoucherRow[] | null;
    lastFetch?: Date;
    itinerary?: NaarGoTripItineraryRow | null;
    agencyContact?: NaarGoContactRow | null;
    usefulContacts?: NaarGoContactRow[] | null;
    assistanceArticle?: ArticoloTestoLingua | null;
    passengers?: NaarGoPassengerRow[] | null;

    constructor(data?: INaarGoTripRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : null as any;
            this.arrivalDate = _data["arrivalDate"] ? new Date(_data["arrivalDate"].toString()) : null as any;
            this.destination = _data["destination"] !== undefined ? _data["destination"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(NaarGoTripFlightRow.fromJS(item));
            }
            else {
                this.flights = null as any;
            }
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(NaarGoTripStepRow.fromJS(item));
            }
            else {
                this.steps = null as any;
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NaarGoTripNotaRow.fromJS(item));
            }
            else {
                this.notes = null as any;
            }
            if (Array.isArray(_data["docs"])) {
                this.docs = [] as any;
                for (let item of _data["docs"])
                    this.docs!.push(NaarGoTripDocRow.fromJS(item));
            }
            else {
                this.docs = null as any;
            }
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(NaarGoTripVoucherRow.fromJS(item));
            }
            else {
                this.vouchers = null as any;
            }
            this.lastFetch = _data["lastFetch"] ? new Date(_data["lastFetch"].toString()) : null as any;
            this.itinerary = _data["itinerary"] ? NaarGoTripItineraryRow.fromJS(_data["itinerary"]) : null as any;
            this.agencyContact = _data["agencyContact"] ? NaarGoContactRow.fromJS(_data["agencyContact"]) : null as any;
            if (Array.isArray(_data["usefulContacts"])) {
                this.usefulContacts = [] as any;
                for (let item of _data["usefulContacts"])
                    this.usefulContacts!.push(NaarGoContactRow.fromJS(item));
            }
            else {
                this.usefulContacts = null as any;
            }
            this.assistanceArticle = _data["assistanceArticle"] ? ArticoloTestoLingua.fromJS(_data["assistanceArticle"]) : null as any;
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(NaarGoPassengerRow.fromJS(item));
            }
            else {
                this.passengers = null as any;
            }
        }
    }

    static fromJS(data: any): NaarGoTripRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTripRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : null as any;
        data["arrivalDate"] = this.arrivalDate ? this.arrivalDate.toISOString() : null as any;
        data["destination"] = this.destination !== undefined ? this.destination : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.docs)) {
            data["docs"] = [];
            for (let item of this.docs)
                data["docs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item ? item.toJSON() : null as any);
        }
        data["lastFetch"] = this.lastFetch ? this.lastFetch.toISOString() : null as any;
        data["itinerary"] = this.itinerary ? this.itinerary.toJSON() : null as any;
        data["agencyContact"] = this.agencyContact ? this.agencyContact.toJSON() : null as any;
        if (Array.isArray(this.usefulContacts)) {
            data["usefulContacts"] = [];
            for (let item of this.usefulContacts)
                data["usefulContacts"].push(item ? item.toJSON() : null as any);
        }
        data["assistanceArticle"] = this.assistanceArticle ? this.assistanceArticle.toJSON() : null as any;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface INaarGoTripRow {
    id?: number;
    description?: string;
    departureDate?: Date;
    arrivalDate?: Date | null;
    destination?: string | null;
    status?: EStatoOffertaUtente | null;
    flights?: NaarGoTripFlightRow[] | null;
    steps?: NaarGoTripStepRow[] | null;
    notes?: NaarGoTripNotaRow[] | null;
    docs?: NaarGoTripDocRow[] | null;
    vouchers?: NaarGoTripVoucherRow[] | null;
    lastFetch?: Date;
    itinerary?: NaarGoTripItineraryRow | null;
    agencyContact?: NaarGoContactRow | null;
    usefulContacts?: NaarGoContactRow[] | null;
    assistanceArticle?: ArticoloTestoLingua | null;
    passengers?: NaarGoPassengerRow[] | null;
}

export enum EStatoOffertaUtente {
    Preventivo = "Preventivo",
    PrenotazioneInCorso = "PrenotazioneInCorso",
    Confermata = "Confermata",
    Annullata = "Annullata",
}

export class NaarGoTripFlightRow implements INaarGoTripFlightRow {
    id?: number;
    pnr?: string;
    paxRef?: string;
    departureDate?: Date | null;
    routes?: NaarGoTripFlightRouteRow[];
    notes?: NaarGoTripFlightNoteRow[];

    constructor(data?: INaarGoTripFlightRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : null as any;
            this.paxRef = _data["paxRef"] !== undefined ? _data["paxRef"] : null as any;
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : null as any;
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(NaarGoTripFlightRouteRow.fromJS(item));
            }
            else {
                this.routes = null as any;
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NaarGoTripFlightNoteRow.fromJS(item));
            }
            else {
                this.notes = null as any;
            }
        }
    }

    static fromJS(data: any): NaarGoTripFlightRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTripFlightRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pnr"] = this.pnr !== undefined ? this.pnr : null as any;
        data["paxRef"] = this.paxRef !== undefined ? this.paxRef : null as any;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : null as any;
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface INaarGoTripFlightRow {
    id?: number;
    pnr?: string;
    paxRef?: string;
    departureDate?: Date | null;
    routes?: NaarGoTripFlightRouteRow[];
    notes?: NaarGoTripFlightNoteRow[];
}

export class NaarGoTripFlightRouteRow implements INaarGoTripFlightRouteRow {
    id?: number;
    flightNumber?: number | null;
    departureDate?: Date | null;
    arrivalDate?: Date | null;
    departureAirportCode?: string;
    arrivalAirportCode?: string;
    arrivalAirportName?: string;
    departureAirportName?: string;
    companyCode?: string;
    companyCodeOperating?: string;
    statusCode?: string;
    seats?: number | null;
    class?: string;

    constructor(data?: INaarGoTripFlightRouteRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.flightNumber = _data["flightNumber"] !== undefined ? _data["flightNumber"] : null as any;
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : null as any;
            this.arrivalDate = _data["arrivalDate"] ? new Date(_data["arrivalDate"].toString()) : null as any;
            this.departureAirportCode = _data["departureAirportCode"] !== undefined ? _data["departureAirportCode"] : null as any;
            this.arrivalAirportCode = _data["arrivalAirportCode"] !== undefined ? _data["arrivalAirportCode"] : null as any;
            this.arrivalAirportName = _data["arrivalAirportName"] !== undefined ? _data["arrivalAirportName"] : null as any;
            this.departureAirportName = _data["departureAirportName"] !== undefined ? _data["departureAirportName"] : null as any;
            this.companyCode = _data["companyCode"] !== undefined ? _data["companyCode"] : null as any;
            this.companyCodeOperating = _data["companyCodeOperating"] !== undefined ? _data["companyCodeOperating"] : null as any;
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : null as any;
            this.seats = _data["seats"] !== undefined ? _data["seats"] : null as any;
            this.class = _data["class"] !== undefined ? _data["class"] : null as any;
        }
    }

    static fromJS(data: any): NaarGoTripFlightRouteRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTripFlightRouteRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["flightNumber"] = this.flightNumber !== undefined ? this.flightNumber : null as any;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : null as any;
        data["arrivalDate"] = this.arrivalDate ? this.arrivalDate.toISOString() : null as any;
        data["departureAirportCode"] = this.departureAirportCode !== undefined ? this.departureAirportCode : null as any;
        data["arrivalAirportCode"] = this.arrivalAirportCode !== undefined ? this.arrivalAirportCode : null as any;
        data["arrivalAirportName"] = this.arrivalAirportName !== undefined ? this.arrivalAirportName : null as any;
        data["departureAirportName"] = this.departureAirportName !== undefined ? this.departureAirportName : null as any;
        data["companyCode"] = this.companyCode !== undefined ? this.companyCode : null as any;
        data["companyCodeOperating"] = this.companyCodeOperating !== undefined ? this.companyCodeOperating : null as any;
        data["statusCode"] = this.statusCode !== undefined ? this.statusCode : null as any;
        data["seats"] = this.seats !== undefined ? this.seats : null as any;
        data["class"] = this.class !== undefined ? this.class : null as any;
        return data;
    }
}

export interface INaarGoTripFlightRouteRow {
    id?: number;
    flightNumber?: number | null;
    departureDate?: Date | null;
    arrivalDate?: Date | null;
    departureAirportCode?: string;
    arrivalAirportCode?: string;
    arrivalAirportName?: string;
    departureAirportName?: string;
    companyCode?: string;
    companyCodeOperating?: string;
    statusCode?: string;
    seats?: number | null;
    class?: string;
}

export class NaarGoTripFlightNoteRow implements INaarGoTripFlightNoteRow {
    id?: number;
    type?: EPnrNoteTitle | null;
    tipoMemo?: string;
    text?: string;
    date?: Date | null;

    constructor(data?: INaarGoTripFlightNoteRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.tipoMemo = _data["tipoMemo"] !== undefined ? _data["tipoMemo"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
        }
    }

    static fromJS(data: any): NaarGoTripFlightNoteRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTripFlightNoteRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["tipoMemo"] = this.tipoMemo !== undefined ? this.tipoMemo : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        return data;
    }
}

export interface INaarGoTripFlightNoteRow {
    id?: number;
    type?: EPnrNoteTitle | null;
    tipoMemo?: string;
    text?: string;
    date?: Date | null;
}

export enum EPnrNoteTitle {
    UNKNOWN = "UNKNOWN",
    CONTACT = "CONTACT",
    EMISSION_OK = "EMISSION_OK",
    EMISSION_INF = "EMISSION_INF",
    EMISSION_PAX = "EMISSION_PAX",
    TICKET = "TICKET",
    COMPANY_MSG = "COMPANY_MSG",
    TICKET_RULE = "TICKET_RULE",
    TICKET_SPLIT = "TICKET_SPLIT",
    COMMISSION = "COMMISSION",
    PIN = "PIN",
    TIME_LIMIT = "TIME_LIMIT",
    FIRM = "FIRM",
    PROPERTY = "PROPERTY",
    NOTE = "NOTE",
    COMPANY_NOTE = "COMPANY_NOTE",
    COMPANY_NOTE_OTHERS = "COMPANY_NOTE_OTHERS",
    CONFIRMET_PLACE = "CONFIRMET_PLACE",
    RQ_PLACE = "RQ_PLACE",
    INF_PLACE = "INF_PLACE",
    FORM_OF_PAYMENT = "FORM_OF_PAYMENT",
    VECTOR_INFO = "VECTOR_INFO",
    FREQUENT_FLYER = "FREQUENT_FLYER",
    EXTRA_INFOS = "EXTRA_INFOS",
}

export class NaarGoTripStepRow implements INaarGoTripStepRow {
    id?: number;
    serviceId?: number | null;
    name?: string;
    description?: string;
    startDate?: Date | null;
    endDate?: Date | null;
    day?: number | null;
    notes?: string;
    clientNotes?: string;
    quantity?: number | null;
    type?: ETipoServizio;
    imageUrl?: string | null;
    serviceAddress?: string | null;

    constructor(data?: INaarGoTripStepRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.day = _data["day"] !== undefined ? _data["day"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.clientNotes = _data["clientNotes"] !== undefined ? _data["clientNotes"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.serviceAddress = _data["serviceAddress"] !== undefined ? _data["serviceAddress"] : null as any;
        }
    }

    static fromJS(data: any): NaarGoTripStepRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTripStepRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["day"] = this.day !== undefined ? this.day : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["clientNotes"] = this.clientNotes !== undefined ? this.clientNotes : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["serviceAddress"] = this.serviceAddress !== undefined ? this.serviceAddress : null as any;
        return data;
    }
}

export interface INaarGoTripStepRow {
    id?: number;
    serviceId?: number | null;
    name?: string;
    description?: string;
    startDate?: Date | null;
    endDate?: Date | null;
    day?: number | null;
    notes?: string;
    clientNotes?: string;
    quantity?: number | null;
    type?: ETipoServizio;
    imageUrl?: string | null;
    serviceAddress?: string | null;
}

export class NaarGoTripNotaRow implements INaarGoTripNotaRow {
    type?: ETipoNota;
    text?: string;
    date?: Date;

    constructor(data?: INaarGoTripNotaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
        }
    }

    static fromJS(data: any): NaarGoTripNotaRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTripNotaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        return data;
    }
}

export interface INaarGoTripNotaRow {
    type?: ETipoNota;
    text?: string;
    date?: Date;
}

export enum ETipoNota {
    Interna = "Interna",
    PreventivoSingola = "PreventivoSingola",
    PreventivoMultipla = "PreventivoMultipla",
    Agenzia = "Agenzia",
    RispostaAgenzia = "RispostaAgenzia",
    Assistenza = "Assistenza",
    Passeggero = "Passeggero",
    Operatore = "Operatore",
    Documento = "Documento",
}

export class NaarGoTripDocRow implements INaarGoTripDocRow {
    document?: Documento;
    name?: string | null;
    bytes?: string | null;
    html?: string | null;
    contentType?: string | null;
    extraDocIDs?: number[];

    constructor(data?: INaarGoTripDocRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? Documento.fromJS(_data["document"]) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.bytes = _data["bytes"] !== undefined ? _data["bytes"] : null as any;
            this.html = _data["html"] !== undefined ? _data["html"] : null as any;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null as any;
            if (Array.isArray(_data["extraDocIDs"])) {
                this.extraDocIDs = [] as any;
                for (let item of _data["extraDocIDs"])
                    this.extraDocIDs!.push(item);
            }
            else {
                this.extraDocIDs = null as any;
            }
        }
    }

    static fromJS(data: any): NaarGoTripDocRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTripDocRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["bytes"] = this.bytes !== undefined ? this.bytes : null as any;
        data["html"] = this.html !== undefined ? this.html : null as any;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null as any;
        if (Array.isArray(this.extraDocIDs)) {
            data["extraDocIDs"] = [];
            for (let item of this.extraDocIDs)
                data["extraDocIDs"].push(item);
        }
        return data;
    }
}

export interface INaarGoTripDocRow {
    document?: Documento;
    name?: string | null;
    bytes?: string | null;
    html?: string | null;
    contentType?: string | null;
    extraDocIDs?: number[];
}

export class Documento implements IDocumento {
    documentoID?: number;
    offertaID?: number;
    contattoID?: number | null;
    tipoDocumento?: ETipoDocumento;
    testata?: string | null;
    corpo?: string | null;
    corpo2?: string | null;
    data?: Date | null;
    userID?: number | null;
    spedito?: Date | null;
    contatoreSpedizioni?: number | null;
    rootID?: number;
    opzioni?: string | null;
    storage?: EStorage;

    constructor(data?: IDocumento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : null as any;
            this.corpo = _data["corpo"] !== undefined ? _data["corpo"] : null as any;
            this.corpo2 = _data["corpo2"] !== undefined ? _data["corpo2"] : null as any;
            this.data = _data["data"] ? new Date(_data["data"].toString()) : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.spedito = _data["spedito"] ? new Date(_data["spedito"].toString()) : null as any;
            this.contatoreSpedizioni = _data["contatoreSpedizioni"] !== undefined ? _data["contatoreSpedizioni"] : null as any;
            this.rootID = _data["rootID"] !== undefined ? _data["rootID"] : null as any;
            this.opzioni = _data["opzioni"] !== undefined ? _data["opzioni"] : null as any;
            this.storage = _data["storage"] !== undefined ? _data["storage"] : null as any;
        }
    }

    static fromJS(data: any): Documento {
        data = typeof data === 'object' ? data : {};
        let result = new Documento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["testata"] = this.testata !== undefined ? this.testata : null as any;
        data["corpo"] = this.corpo !== undefined ? this.corpo : null as any;
        data["corpo2"] = this.corpo2 !== undefined ? this.corpo2 : null as any;
        data["data"] = this.data ? this.data.toISOString() : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["spedito"] = this.spedito ? this.spedito.toISOString() : null as any;
        data["contatoreSpedizioni"] = this.contatoreSpedizioni !== undefined ? this.contatoreSpedizioni : null as any;
        data["rootID"] = this.rootID !== undefined ? this.rootID : null as any;
        data["opzioni"] = this.opzioni !== undefined ? this.opzioni : null as any;
        data["storage"] = this.storage !== undefined ? this.storage : null as any;
        return data;
    }
}

export interface IDocumento {
    documentoID?: number;
    offertaID?: number;
    contattoID?: number | null;
    tipoDocumento?: ETipoDocumento;
    testata?: string | null;
    corpo?: string | null;
    corpo2?: string | null;
    data?: Date | null;
    userID?: number | null;
    spedito?: Date | null;
    contatoreSpedizioni?: number | null;
    rootID?: number;
    opzioni?: string | null;
    storage?: EStorage;
}

export enum ETipoDocumento {
    Generico = "Generico",
    NotaCredito = "NotaCredito",
    Fattura = "Fattura",
    EstrattoConto = "EstrattoConto",
    Autofattura = "Autofattura",
    RapportoContabile = "RapportoContabile",
    Offerta = "Offerta",
    Conferma = "Conferma",
    Prenotazione = "Prenotazione",
    Voucher = "Voucher",
    ProgrammaViaggio = "ProgrammaViaggio",
    PreventivoCliente = "PreventivoCliente",
    Miniguida = "Miniguida",
    Corrispondenza = "Corrispondenza",
    EstrattoContoConfermaServizi = "EstrattoContoConfermaServizi",
    NotaCreditoOrdinaria = "NotaCreditoOrdinaria",
    FatturaOrdinaria = "FatturaOrdinaria",
    RiepilogoPrenotazioni = "RiepilogoPrenotazioni",
    RiepilogoPrenotazioniAccordo = "RiepilogoPrenotazioniAccordo",
    RiepilogoPrenotazioniNU = "RiepilogoPrenotazioniNU",
    StornoAutofattura = "StornoAutofattura",
    FatturaAcquisto = "FatturaAcquisto",
    NotaCreditoAcquisto = "NotaCreditoAcquisto",
    FatturaAcquistoOrdinaria = "FatturaAcquistoOrdinaria",
    NotaCreditoAcquistoOrdinaria = "NotaCreditoAcquistoOrdinaria",
    RispostaPrenotazione = "RispostaPrenotazione",
    PrenotazioneH2H = "PrenotazioneH2H",
    DocumentiDiViaggio = "DocumentiDiViaggio",
    MultiDocumento = "MultiDocumento",
    MailPrenotazioneClienteFinale = "MailPrenotazioneClienteFinale",
    Biglietteria = "Biglietteria",
    Assicurazioni = "Assicurazioni",
    MailConfermaClienteFinale = "MailConfermaClienteFinale",
    RispostaPerAdv = "RispostaPerAdv",
    DocumentoContabile = "DocumentoContabile",
    PreventivoClienteTraducibile = "PreventivoClienteTraducibile",
    ProgrammaViaggioTraducibile = "ProgrammaViaggioTraducibile",
    DocumentoCondiviso = "DocumentoCondiviso",
    AutofatturaBis = "AutofatturaBis",
    NotaDiDebito = "NotaDiDebito",
    NotaDiDebitoOrdinaria = "NotaDiDebitoOrdinaria",
    VoucherTuristico = "VoucherTuristico",
    PreventivoClientePlus = "PreventivoClientePlus",
    ConfermaCliente = "ConfermaCliente",
    ConfermaProvvisoriaAgenzia = "ConfermaProvvisoriaAgenzia",
    EstrattoContoPenale = "EstrattoContoPenale",
    ProgrammaViaggio2022 = "ProgrammaViaggio2022",
    ProgrammaViaggio2023 = "ProgrammaViaggio2023",
    Kanban = "Kanban",
}

export enum EStorage {
    Unknown = "Unknown",
    SharedFilesystem = "SharedFilesystem",
    AzureMedia = "AzureMedia",
    Database = "Database",
}

export class NaarGoTripVoucherRow implements INaarGoTripVoucherRow {
    number?: string;
    voucher?: Voucher;
    title?: string;
    isWedding?: boolean;
    html?: string;

    constructor(data?: INaarGoTripVoucherRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.isWedding = _data["isWedding"] !== undefined ? _data["isWedding"] : null as any;
            this.html = _data["html"] !== undefined ? _data["html"] : null as any;
        }
    }

    static fromJS(data: any): NaarGoTripVoucherRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTripVoucherRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["isWedding"] = this.isWedding !== undefined ? this.isWedding : null as any;
        data["html"] = this.html !== undefined ? this.html : null as any;
        return data;
    }
}

export interface INaarGoTripVoucherRow {
    number?: string;
    voucher?: Voucher;
    title?: string;
    isWedding?: boolean;
    html?: string;
}

export class Voucher implements IVoucher {
    voucherID?: number;
    offertaID?: number | null;
    ordine?: number | null;
    testata?: string | null;
    bookingRef?: string | null;
    clienti?: string | null;
    descrizioneServizio?: string | null;
    periodo?: string | null;
    dettaglio?: string | null;
    istruzioni?: string | null;
    servizioID?: number | null;
    lingua?: ELingua | null;
    versione?: number;

    constructor(data?: IVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voucherID = _data["voucherID"] !== undefined ? _data["voucherID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : null as any;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : null as any;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : null as any;
            this.descrizioneServizio = _data["descrizioneServizio"] !== undefined ? _data["descrizioneServizio"] : null as any;
            this.periodo = _data["periodo"] !== undefined ? _data["periodo"] : null as any;
            this.dettaglio = _data["dettaglio"] !== undefined ? _data["dettaglio"] : null as any;
            this.istruzioni = _data["istruzioni"] !== undefined ? _data["istruzioni"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.versione = _data["versione"] !== undefined ? _data["versione"] : null as any;
        }
    }

    static fromJS(data: any): Voucher {
        data = typeof data === 'object' ? data : {};
        let result = new Voucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherID"] = this.voucherID !== undefined ? this.voucherID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["testata"] = this.testata !== undefined ? this.testata : null as any;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : null as any;
        data["clienti"] = this.clienti !== undefined ? this.clienti : null as any;
        data["descrizioneServizio"] = this.descrizioneServizio !== undefined ? this.descrizioneServizio : null as any;
        data["periodo"] = this.periodo !== undefined ? this.periodo : null as any;
        data["dettaglio"] = this.dettaglio !== undefined ? this.dettaglio : null as any;
        data["istruzioni"] = this.istruzioni !== undefined ? this.istruzioni : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["versione"] = this.versione !== undefined ? this.versione : null as any;
        return data;
    }
}

export interface IVoucher {
    voucherID?: number;
    offertaID?: number | null;
    ordine?: number | null;
    testata?: string | null;
    bookingRef?: string | null;
    clienti?: string | null;
    descrizioneServizio?: string | null;
    periodo?: string | null;
    dettaglio?: string | null;
    istruzioni?: string | null;
    servizioID?: number | null;
    lingua?: ELingua | null;
    versione?: number;
}

export class NaarGoTripItineraryRow implements INaarGoTripItineraryRow {
    itineraries?: NaarGoTripItineraryStepRow[];

    constructor(data?: INaarGoTripItineraryRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["itineraries"])) {
                this.itineraries = [] as any;
                for (let item of _data["itineraries"])
                    this.itineraries!.push(NaarGoTripItineraryStepRow.fromJS(item));
            }
            else {
                this.itineraries = null as any;
            }
        }
    }

    static fromJS(data: any): NaarGoTripItineraryRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTripItineraryRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itineraries)) {
            data["itineraries"] = [];
            for (let item of this.itineraries)
                data["itineraries"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface INaarGoTripItineraryRow {
    itineraries?: NaarGoTripItineraryStepRow[];
}

export class NaarGoTripItineraryStepRow implements INaarGoTripItineraryStepRow {
    arrivalDate?: Date | null;
    departureDate?: Date | null;
    destination?: string | null;
    coverImage?: string | null;
    servicesRowsIDs?: number[] | null;

    constructor(data?: INaarGoTripItineraryStepRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arrivalDate = _data["arrivalDate"] ? new Date(_data["arrivalDate"].toString()) : null as any;
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : null as any;
            this.destination = _data["destination"] !== undefined ? _data["destination"] : null as any;
            this.coverImage = _data["coverImage"] !== undefined ? _data["coverImage"] : null as any;
            if (Array.isArray(_data["servicesRowsIDs"])) {
                this.servicesRowsIDs = [] as any;
                for (let item of _data["servicesRowsIDs"])
                    this.servicesRowsIDs!.push(item);
            }
            else {
                this.servicesRowsIDs = null as any;
            }
        }
    }

    static fromJS(data: any): NaarGoTripItineraryStepRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoTripItineraryStepRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrivalDate"] = this.arrivalDate ? this.arrivalDate.toISOString() : null as any;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : null as any;
        data["destination"] = this.destination !== undefined ? this.destination : null as any;
        data["coverImage"] = this.coverImage !== undefined ? this.coverImage : null as any;
        if (Array.isArray(this.servicesRowsIDs)) {
            data["servicesRowsIDs"] = [];
            for (let item of this.servicesRowsIDs)
                data["servicesRowsIDs"].push(item);
        }
        return data;
    }
}

export interface INaarGoTripItineraryStepRow {
    arrivalDate?: Date | null;
    departureDate?: Date | null;
    destination?: string | null;
    coverImage?: string | null;
    servicesRowsIDs?: number[] | null;
}

export class NaarGoContactRow implements INaarGoContactRow {
    contactID?: number;
    name?: string | null;
    lastName?: string | null;
    address?: string | null;
    houseNumber?: string | null;
    cap?: string | null;
    place?: string | null;
    province?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    logoUrl?: string | null;

    constructor(data?: INaarGoContactRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.houseNumber = _data["houseNumber"] !== undefined ? _data["houseNumber"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.place = _data["place"] !== undefined ? _data["place"] : null as any;
            this.province = _data["province"] !== undefined ? _data["province"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : null as any;
        }
    }

    static fromJS(data: any): NaarGoContactRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoContactRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactID"] = this.contactID !== undefined ? this.contactID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["houseNumber"] = this.houseNumber !== undefined ? this.houseNumber : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["place"] = this.place !== undefined ? this.place : null as any;
        data["province"] = this.province !== undefined ? this.province : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : null as any;
        return data;
    }
}

export interface INaarGoContactRow {
    contactID?: number;
    name?: string | null;
    lastName?: string | null;
    address?: string | null;
    houseNumber?: string | null;
    cap?: string | null;
    place?: string | null;
    province?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    logoUrl?: string | null;
}

export class ArticoloTestoLingua implements IArticoloTestoLingua {
    articoloID?: number;
    articoloTraduzioneID?: number | null;
    lingua?: ELingua;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    confermato?: boolean;
    ultimoAggiornamento?: Date | null;

    constructor(data?: IArticoloTestoLingua) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
            this.articoloTraduzioneID = _data["articoloTraduzioneID"] !== undefined ? _data["articoloTraduzioneID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.confermato = _data["confermato"] !== undefined ? _data["confermato"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] ? new Date(_data["ultimoAggiornamento"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ArticoloTestoLingua {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTestoLingua();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        data["articoloTraduzioneID"] = this.articoloTraduzioneID !== undefined ? this.articoloTraduzioneID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["sunto"] = this.sunto !== undefined ? this.sunto : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["confermato"] = this.confermato !== undefined ? this.confermato : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento ? this.ultimoAggiornamento.toISOString() : null as any;
        return data;
    }
}

export interface IArticoloTestoLingua {
    articoloID?: number;
    articoloTraduzioneID?: number | null;
    lingua?: ELingua;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    confermato?: boolean;
    ultimoAggiornamento?: Date | null;
}

export class NaarGoPassengerRow implements INaarGoPassengerRow {
    name?: string;
    birthDate?: Date | null;
    phone?: string | null;
    email?: string | null;

    constructor(data?: INaarGoPassengerRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): NaarGoPassengerRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoPassengerRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface INaarGoPassengerRow {
    name?: string;
    birthDate?: Date | null;
    phone?: string | null;
    email?: string | null;
}

export class GetTripRequest extends NaarGoRequest implements IGetTripRequest {
    tripId?: number;

    constructor(data?: IGetTripRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripId = _data["tripId"] !== undefined ? _data["tripId"] : null as any;
        }
    }

    static override fromJS(data: any): GetTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripId"] = this.tripId !== undefined ? this.tripId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripRequest extends INaarGoRequest {
    tripId?: number;
}

export class ListTripsResponse extends OkNaarGoResponse implements IListTripsResponse {
    tripHeaders?: TripHeader[];

    constructor(data?: IListTripsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tripHeaders"])) {
                this.tripHeaders = [] as any;
                for (let item of _data["tripHeaders"])
                    this.tripHeaders!.push(TripHeader.fromJS(item));
            }
            else {
                this.tripHeaders = null as any;
            }
        }
    }

    static override fromJS(data: any): ListTripsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTripsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tripHeaders)) {
            data["tripHeaders"] = [];
            for (let item of this.tripHeaders)
                data["tripHeaders"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListTripsResponse extends IOkNaarGoResponse {
    tripHeaders?: TripHeader[];
}

export class TripHeader implements ITripHeader {
    id?: number;
    name?: string | null;

    constructor(data?: ITripHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): TripHeader {
        data = typeof data === 'object' ? data : {};
        let result = new TripHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface ITripHeader {
    id?: number;
    name?: string | null;
}

export class AddTripRequest extends GetTripRequest implements IAddTripRequest {

    constructor(data?: IAddTripRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AddTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddTripRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAddTripRequest extends IGetTripRequest {
}

export class RemoveTripRequest extends GetTripRequest implements IRemoveTripRequest {

    constructor(data?: IRemoveTripRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RemoveTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveTripRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRemoveTripRequest extends IGetTripRequest {
}

export class NaarGoEditUserResponse extends OkNaarGoResponse implements INaarGoEditUserResponse {
    user?: NaarGoUserRow;

    constructor(data?: INaarGoEditUserResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? NaarGoUserRow.fromJS(_data["user"]) : null as any;
        }
    }

    static override fromJS(data: any): NaarGoEditUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoEditUserResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoEditUserResponse extends IOkNaarGoResponse {
    user?: NaarGoUserRow;
}

export class NaarGoEditUserRequest extends NaarGoRequest implements INaarGoEditUserRequest {
    name!: string;
    lastname!: string;
    emailAddress!: string;
    language!: ELingua;
    id!: number;

    constructor(data?: INaarGoEditUserRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoEditUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoEditUserRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["lastname"] = this.lastname !== undefined ? this.lastname : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoEditUserRequest extends INaarGoRequest {
    name: string;
    lastname: string;
    emailAddress: string;
    language: ELingua;
    id: number;
}

export class NaarGoChangePasswordRequest extends NaarGoRequest implements INaarGoChangePasswordRequest {
    oldPassword!: string;
    password!: string;
    id!: number;

    constructor(data?: INaarGoChangePasswordRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldPassword = _data["oldPassword"] !== undefined ? _data["oldPassword"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoChangePasswordRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword !== undefined ? this.oldPassword : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoChangePasswordRequest extends INaarGoRequest {
    oldPassword: string;
    password: string;
    id: number;
}

export class NaarGoDeleteUserRequest extends NaarGoRequest implements INaarGoDeleteUserRequest {
    id!: number;

    constructor(data?: INaarGoDeleteUserRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoDeleteUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoDeleteUserRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoDeleteUserRequest extends INaarGoRequest {
    id: number;
}

export class GetSystemResponse extends OkNaarGoResponse implements IGetSystemResponse {
    system?: NaarGoUserRow;

    constructor(data?: IGetSystemResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.system = _data["system"] ? NaarGoUserRow.fromJS(_data["system"]) : null as any;
        }
    }

    static override fromJS(data: any): GetSystemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system ? this.system.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSystemResponse extends IOkNaarGoResponse {
    system?: NaarGoUserRow;
}

export class GetAdminsResponse extends OkNaarGoResponse implements IGetAdminsResponse {
    admins?: NaarGoUserRowLite[];

    constructor(data?: IGetAdminsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["admins"])) {
                this.admins = [] as any;
                for (let item of _data["admins"])
                    this.admins!.push(NaarGoUserRowLite.fromJS(item));
            }
            else {
                this.admins = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAdminsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdminsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.admins)) {
            data["admins"] = [];
            for (let item of this.admins)
                data["admins"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdminsResponse extends IOkNaarGoResponse {
    admins?: NaarGoUserRowLite[];
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}